/**
 * 繁體中文文案（zh-TW）
 * 按命名空間分組：common / member / cancel / permission / user / privacy
 * 需在 src/i18n/index.js 的 localeMap 中註冊 'zh-TW'，否則會回退到 zh-CN（簡體）。
 *
 * 所有協議均採用「模板佔位 + 多語言文案」結構：
 *   - user    → src/agreements/user/template.js（用戶協議，文字提取至下方 user 命名空間，用 {{user.xxx}} 佔位符）
 *   - privacy → src/agreements/privacy/template.js（隱私政策，文字提取至下方 privacy 命名空間，用 {{privacy.xxx}} 佔位符）
 * 下方保留帶 {{佔位符}} 的 common/member/cancel/permission/user/privacy 等命名空間。
 */
export default {
  common: {
    // 多公司（品牌）分组：qy = 轻语Ai，cm = 蚕猫ai
    // URL 参数 ?appname=qy / ?appname=蚕猫ai 切换；未匹配时默认 qy
    // 新增公司：复制一份分组并填字段，留空的字段自动回退 qy
    qy: {
      appName: '輕語Ai',
      companyName: '深圳數芯語科技有限公司',
      contactEmail: 'market@nihaoxiaozhi.com',
      contactAddress: '深圳市光明區鳳凰街道塘尾社區明湖智谷產業園6棟1002',
      appFeedback: '登錄產品界面 → 點擊「聯繫我們」'
    },
    cm: {
      appName: '蠶貓ai',
      // TODO: 补充蚕猫ai 的主体信息，留空字段自动回退 qy
      companyName: '',
      contactEmail: '',
      contactAddress: '',
      appFeedback: ''
    }
  },

  member: {
    titleSuffix: '會員服務協議',
    subtitle: '感謝您選擇我們的會員服務，請仔細閱讀以下條款，註冊即表示您同意接受全部協議內容。',
    benefitsTitle: '會員權益說明',
    card1Title: '會員卡權益',
    card1_li1: '模型特權：暢享更高級的問答模型無限使用特權，擁有更長的記憶對話。',
    card1_li2: '輕語對話：讓心靈的交流不受限制、輕觸心靈的每一個細節。',
    card1_li3: '輕語專享：享受更自然、更親密的對話體驗、讓溫暖常伴左右。',
    card1_li4: '專屬會員：優先踏上新功能的探索之旅，成為時尚科技的前沿弄潮兒。',
    card2Title: '音色卡權益',
    card2_li1: '音色暢享：解鎖海量音色，讓對話更加豐富多彩。',
    card2_li2: '優先特權：優先體驗上新音色，成為引領聲音潮流的先鋒達人。',
    card2_li3: '獨特音色：定制專屬您的獨特音色，展現個性魅力，讓您與眾不同。',
    card3Title: '音樂卡權益',
    card3_li1: '暢聽無阻：海量歌曲等您搜索，享受高品質音樂的純粹體驗。',
    card3_li2: '個性推薦：個性化音樂推薦，輕鬆找到您喜愛的歌曲。',
    card3_li3: '歌單詞庫：專屬類目歌單，與音樂歌詞共同狂歡。',
    card4Title: '新人專享套餐',
    card4_li1: '三效合一：一份套餐同時享有對話音色（音色卡）、高級AI模型（會員卡）與音樂曲庫（音樂卡）三重權益。',
    card4_li2: '新人專享：僅限新註冊用戶購買，每個賬號限購一次。',
    termsTitle: '會員服務協議條款',
    term1Title: '服務條款',
    term1_1: '1.1 本協議是用戶（以下簡稱“您”）與{{common.companyName}}之間就使用會員服務所訂立的協議。您通過網絡頁面點擊確認或以其他方式選擇接受本協議，即表示您同意接受本協議的全部條款和條件。',
    term1_2: '1.2 {{common.companyName}}有權根據業務發展需要對服務內容、服務價格、服務期限等進行調整，並以適當方式通知您。您若繼續使用服務，即視為同意接受調整後的內容。',
    term2Title: '會員權益',
    term2_1: '2.1 會員卡：您可根據自身需求選擇不同類型的會員卡，每種會員卡對應不同的服務內容和價格。具體以{{common.companyName}}官方公佈的信息為準。',
    term2_2: '2.2 服務期限：會員服務期限以您實際購買的服務套餐為準，自購買成功並激活之日起計算。',
    term2_3: '2.3 服務變更：在服務期限內，{{common.companyName}}可能會對會員服務內容進行優化或調整，以提升服務質量和用戶體驗。',
    term3Title: '費用與支付',
    term3_1: '3.1 會員服務費用將根據您選擇的會員類型和服務期限確定，具體金額以支付頁面顯示為準。',
    term3_2: '3.2 您可以選擇適合的支付方式進行支付，支付成功後，服務將立即生效。',
    term3_3: '3.3 除非法律法規另有規定或本協議另有約定，會員服務費用一經支付，不予退還。',
    term4Title: '用戶權利與義務',
    term4_1: '4.1 您有權在服務期限內按照本協議約定使用相應的會員服務。',
    term4_2: '4.2 您應遵守本協議及{{common.companyName}}制定的相關規則，不得利用會員服務從事任何違法、違規或侵犯他人權益的活動。',
    term4_3: '4.3 您應妥善保管您的賬號和密碼，不得將賬號共享或轉讓給他人使用。因您保管不善導致的損失由您自行承擔。',
    term5Title: '隱私保護',
    term5_1: '5.1 {{common.companyName}}尊重並保護您的隱私，將按照{{common.companyName}}的隱私政策收集、使用和保護您的個人信息。',
    term5_2: '5.2 您同意{{common.companyName}}在提供服務過程中可能會收集和使用您的相關信息，包括但不限於使用記錄、設備信息等。',
    term6Title: '協議變更',
    term6_1: '{{common.companyName}}有權隨時修改本協議的條款，修改後的協議將通過適當方式通知您。',
    footerRights: '保留所有權利',
    footerPrivacy: '隱私政策',
    footerTerms: '服務條款'
  },

  cancel: {
    title: '註銷須知',
    important1: '重要提示：在您註銷賬號之前，請閱讀、理解並同意如下事項：',
    important2: '特別提示：註銷賬號是不可恢復的操作。註銷後，您將無法使用本賬號，也無法找回因註銷、刪除而被刪除或匿名化的任何內容或信息（即使您使用相同的手機號重新註冊並使用本產品）。{{common.appName}}賬號指您依據由{{common.companyName}}運營的《{{common.appName}}用戶協議》所創建，供您作為註冊用戶登錄並使用本產品及服務的憑證。',
    p1: '請您確保申請註銷的賬號是您依據《{{common.appName}}用戶協議》創建並提供給我們的賬號。您應按照我們規定的程序或網站上的提示進行上述賬號的註銷。',
    p2: '在註銷賬號之前，您應自行備份與該賬號相關的所有信息和數據，並確認與該賬號相關的所有服務均已妥善處理。註銷完成後，我們將刪除您的個人信息或對其進行匿名化處理（法律法規另有規定的除外）。',
    p3: '我們深表遺憾您做出註銷賬號的決定。如果您仍決定繼續進行賬號註銷，您的賬號必須同時符合以下條件：',
    cond1Title: '賬號處於安全狀態',
    cond1: '該賬號處於正常使用中，且通過平台安全檢查，不存在被盜、違規或封禁等風險。通過先進的安全監測系統，我們會實時監控賬號的登錄行為和操作記錄，確保賬號未被異常登錄或用於任何違反平台規則的活動。例如，若發現賬號異地登錄或進行了異常頻繁的敏感操作，將視為不符合安全狀態條件，無法註銷。',
    cond2Title: '賬號財產已結清、交易已完結',
    cond2: '該賬號下所有相關的資產、預期收益及權益均已結清、退款、清空或自願放棄。這包括但不限於您已購買的付費充值、虛擬物品或服務，以及您在本平台進行的各類交易。我們會仔細核對您賬號下的每一筆交易記錄，確保不存在未結清的費用、未完結的退款流程或未處理完畢的權益。例如，若您購買了某項增值服務且服務期限尚未屆滿，但您決定註銷賬號，我們會確認您是否已獲取該對應服務的全部權益，或是否已按規定申請並辦理了合理的退款。只有當與賬號關聯的所有財務事宜均已妥善解決，才滿足此註銷條件。',
    cond3Title: '賬號權限已釋放',
    cond3: '該賬號已解除與其他產品的授權登錄或綁定關係。在您使用{{common.appName}}的過程中，您可能曾與其他第三方產品/服務進行過授權登錄或綁定操作。在註銷賬號前，您需要確保上述所有關聯關係均已解除。我們會與相關第三方系統進行數據交互驗證，確認該賬號不再與其他外部產品存在授權關係。例如，若您曾使用{{common.appName}}賬號登錄過某第三方閱讀應用，並授予該應用某些訪問權限，那麼在註銷{{common.appName}}賬號時，您需要先在該第三方應用中取消對{{common.appName}}賬號的授權，否則無法完成賬號註銷流程。',
    cond4Title: '賬號無爭議',
    cond4: '該賬號不存在任何未完成和/或存在爭議的服務。賬號不存在未解決的爭議，包括但不限於被投訴、舉報、侵權糾紛等。我們會全面審查您賬號的歷史記錄，排查是否存在用戶間的糾紛、投訴或舉報，以及是否涉及侵權等情況。例如，若您因不當言論或行為被其他用戶投訴，或者您投訴了其他用戶的某些行為侵犯了您的權益，在這些爭議妥善解決之前，該賬號無法註銷。只有當賬號處於無爭議狀態時，方可進入下一步註銷環節。',
    conseqTitle: '本賬號註銷後，您將無法登錄、使用本賬號，包括但不限於：',
    conseq1: '您將無法在本產品中登錄、使用該賬號。這是註銷賬號最直接的結果，註銷完成後，系統會徹底清除該賬號相關的登錄憑證和權限信息，您將無法再通過此賬號訪問{{common.appName}}的任何功能或服務。',
    conseq2: '您將無法找回您輸入、上傳或接收回覆的任何內容或信息。一旦賬號註銷，與之相關的所有交互數據，包括您提出的問題、上傳的文件、與{{common.appName}}的對話記錄以及接收到的回覆內容等，都將被刪除或匿名化處理，無法找回。請您在註銷前謹慎考慮是否需要保留這些重要信息。',
    conseq3: '您將無法找回該賬號相關的賬號內任何內容或信息，包括賬號的個人資料和歷史信息（含賬戶資料信息及操作信息等）。這涵蓋了您註冊賬號時填寫的個人信息，如暱稱、頭像、聯繫方式等，以及您使用過程中的所有操作記錄，如登錄時間、瀏覽歷史、設置變更等。這些信息將隨著賬號的註銷而永久丟失，無法恢復。',
    p4: '在賬號註銷期間，若您的賬號涉及爭議，包括但不限於：投訴、舉報、訴訟、仲裁、被國家主管機關調查等，您理解並同意{{common.appName}}有權決定是否終止本賬號的註銷而無需再取得您的另行授權。這是為了維護平台的正常運營秩序以及保障用戶權益。在賬號註銷過程中，若出現任何可能影響平台規則執行或涉及其他用戶權益的爭議情況，我們會根據具體情況進行判斷。例如，若您的賬號因嚴重違規行為被其他用戶投訴，且投訴正在調查階段，為了確保調查的公正性和有效性，我們有權暫停該賬號的註銷流程，直至爭議解決。在爭議妥善解決後，我們會根據最終結果決定是否繼續該賬號的註銷操作。',
    p5: '註銷本賬號不代表您註銷前的行為和相關責任得以免除或減輕。即使賬號已註銷，您在使用{{common.appName}}服務期間產生的任何行為及責任，仍受相關法律法規及平台規則的約束。例如，若您在賬號註銷前違反了《{{common.appName}}用戶協議》的某些條款，如發佈違法違規內容、侵犯他人知識產權等，我們仍有權依據相關規定追究您的責任。您需對賬號註銷前的一切行為和決定承擔全部法律後果，賬號註銷不能成為逃避責任的途徑。',
    p6: '請在做出謹慎的註銷賬號決定前，仔細閱讀並充分理解以上全部條款。若您確認符合上述所有條件並決定註銷賬號，請按照我們規定的程序或網站上的提示進行操作。如您有任何疑問，歡迎隨時聯繫我們的客服團隊，我們將竭誠為您解答。'
  },

  permission: {
    title: '應用權限申請與使用情況說明',
    androidTitle: '一、Android 操作系統申請權限列表',
    androidCardTitle: 'CAMERA',
    cardDescLabel: '權限功能說明',
    androidCardDesc: '使用相機拍攝照片、視頻',
    cardUseLabel: '使用場景或用途',
    androidCardUse: '用於幫助您完成拍攝、發送圖片等功能',
    iosTitle: '二、iOS 操作系統申請權限列表',
    iosCardTitle: 'NSCameraUsageDescription',
    iosCardDesc: '使用相機',
    iosCardUse: '用於幫助您完成拍攝、發送圖片等功能',
    thirdPartyTitle: '三、第三方 SDK 及第三方開發的 H5 頁面或小程序申請的權限',
    sdkTitle: '（一）第三方 SDK 申請的權限',
    sdkPermTitle: '1. 權限申請',
    sdkPerm1: '網絡權限（INTERNET）：用於與第三方服務器通信以獲取必要的數據或服務，確保 SDK 正常運行。例如，一些用於提供廣告服務的 SDK 需要聯網獲取廣告素材並展示信息。',
    sdkPerm2: '存儲權限（READ_EXTERNAL_STORAGE、WRITE_EXTERNAL_STORAGE）：部分 SDK 可能需要讀取或寫入外部存儲權限，以存儲或獲取相關數據。例如，用於緩存應用數據的 SDK 可能需要寫入存儲權限來保存臨時文件。',
    sdkPerm3: '設備信息權限（如 READ_PHONE_STATE）：獲取相關設備信息，如設備型號、IMEI 號等，以便 SDK 能根據設備特徵提供更合適的服務或進行統計分析。',
    sdkUseTitle: '2. 用途說明',
    sdkUse1: '我們引入第三方 SDK 是為了增強{{common.appName}}的功能，如提供更豐富的內容推薦、廣告投放管理、性能監控等服務。使用這些 SDK 是為了實現產品的特定業務功能，我們會盡合理努力確保第三方在利用您的個人信息時遵循合法、正當、必要原則。',
    sdkUse2: '例如，廣告 SDK 用於在產品中展示相關廣告，以支撐產品的運營和發展，但不會收集與廣告展示無關的個人信息。性能監控 SDK 有助於我們了解產品在不同設備上的運行情況，從而及時優化性能，提升您的體驗，同樣不會過度收集您的個人信息。',
    sdkListTitle: '3. 第三方 SDK 列表',
    sdkList1: 'APP 支付客戶端 SDK（包名：com.alipay.sdk）：由支付寶（杭州）信息技術有限公司開發，收集支付訂單信息、設備標識符、網絡信息，用於實現支付功能。',
    sdkList2: '微信開放 SDK（包名：com.tencent.mm.opensdk）：由深圳市騰訊計算機系統有限公司開發，收集微信用戶標識、設備標識符、網絡信息，用於實現微信登錄與分享功能。',
    h5Title: '（二）第三方開發的 H5 頁面或小程序申請的權限',
    h5PermTitle: '1. 權限申請',
    h5Perm1: '位置權限（ACCESS_FINE_LOCATION、ACCESS_COARSE_LOCATION）：若 H5 頁面或小程序提供基於位置的服務，如附近信息查詢、本地生活服務推薦等，可能會申請位置權限以獲取您的地理位置信息。',
    h5Perm2: '麥克風權限（RECORD_AUDIO）：在一些需要進行語音交互或語音識別功能的 H5 頁面或小程序中，可能會申請麥克風權限，以實現語音輸入和交互功能。',
    h5UseTitle: '2. 用途說明',
    h5Use1: '這些第三方開發的 H5 頁面或小程序申請權限是為了實現其自身的特定業務功能。我們會對其進行一定的審核和管理，但無法完全控制其權限使用行為。',
    h5Use2: '例如，與位置相關的 H5 頁面或小程序旨在為您提供更貼合本地需求的服務，方便您查找附近的商家、活動等信息。而具備語音交互功能的 H5 頁面或小程序，是為了讓您更便捷地與其交流，無需手動輸入文字。建議您謹慎使用這些 H5 頁面或小程序，並注意保護个人信息安全。若發現其存在不合理的權限申請或使用行為，請及時通過本政策第九章所述方式與我們聯繫。',
    manageTitle: '四、權限管理說明',
    openCloseTitle: '（一）權限開啟與關閉',
    cameraTitle: '1. 相機權限',
    camera1: '相機權限默認不開啟，僅在您明確授權後才用於實現特定功能或服務，您也可撤回授權。',
    camera2: '您可以在設備自身的操作系統中關閉相機權限，以更改同意的範圍或撤回您的授權。具體操作方法如下：',
    cameraStepsLabel: '',
    cameraStepAndroid: 'Android：系統設置 - 應用設置 - 應用管理 - 搜索或找到{{common.appName}} - 權限管理 - 選擇對應權限 - 關閉',
    cameraStepIos: 'iOS：系統設置 - {{common.appName}} - 選擇對應權限 - 關閉',
    camera3: '請注意，具體的關閉方式可能因您的設備型號和系統版本而有所不同。當您進行上述操作時，我們將無法繼續為您提供與撤回同意或授權相對應的服務，也不再收集與這些權限相關的信息，但不會影響此前基於您的授權已開展的個人信息的處理。',
    otherTitle: '2. 其他權限',
    other1: '對於其他可能涉及如網絡、存儲、設備信息等權限，您也可以根據上述類似的系統設置路徑進行管理。例如，若您想關閉網絡權限，可在安卓系統的設置中找到應用網絡管理選項，對{{common.appName}}進行設置；在 iOS 系統中，可在設置的蜂窩網絡或無線局域網選項中調整{{common.appName}}的網絡使用權限。',
    other2: '您有權根據自身需求隨時開啟或關閉這些權限，以控制個人信息的收集和使用。我們尊重您的自主選擇權，致力於為您提供清晰便捷的權限管理方式，讓您更好地保護个人信息安全。',
    changeTitle: '（二）權限變更通知',
    change1: '隨著產品功能的不斷更新和擴展，我們可能會根據實際情況調整權限的申請和使用。如有變更，我們將按照法律法規的要求，通過以下方式及時告知您：',
    changeStep1: '應用內提示：在{{common.appName}}應用內的顯著位置彈出提示框，詳細說明權限變更的內容、原因及對您的影響。',
    changeStep2: '推送通知：向您的設備發送推送消息，提醒您關注權限變更。推送內容將簡要告知您權限調整的關鍵信息。',
    changeStep3: '更新本應用權限申請與使用情況說明：及時更新本文檔，並通過應用內幫助中心、公告欄等渠道向您展示最新的權限申請和使用說明，確保您能全面了解相關變更。',
    change2: '我們將確保您能及時、準確地知悉權限變更情況，以便您做出合理的決策。在進行權限變更前，我們會充分考慮對您個人信息保護的影響，盡量減少不必要的權限申請。若您對權限變更有任何疑問或擔憂，請隨時與我們聯繫，我們將竭誠為您解答，並根據您的合理要求進行處理。',
    otherTitle2: '五、其他說明',
    otherInfo1: '我們重視您對個人權限的控制。如果您對應用權限有任何疑問或擔憂，請隨時與我們聯繫。我們將通過以下方式為您提供幫助：',
    otherOnline: '在線客服：您可以通過{{common.appName}}應用內的在線客服入口隨時與我們的客服人員溝通，他們將為您解答關於應用權限的問題。',
    otherEmail: '客服郵箱：您也可以發送郵件至我們的客服郵箱{{common.contactEmail}}，詳細描述您的問題，我們將在收到郵件後的[X]個工作日內回覆。',
    otherFeedback: '反饋渠道：此外，您還可以通過{{common.appName}}應用內的專屬反饋渠道提交您的意見和建議，我們會認真對待每一條反饋，並及時處理您關於應用權限的關切。',
    otherInfo2: '我們將持續優化產品的權限管理機制，在滿足產品功能和安全需求的同時，最大程度地保障您的个人信息安全和隱私。我們會定期審查和評估應用權限的使用情況，不斷改進權限申請和使用的合理性和必要性。如果您發現任何異常的權限申請或使用行為，請立即告知我們，我們將及時進行調查和處理。',
    otherInfo3: '通過上述對應用權限申請和使用的詳細說明，我們希望您能更清晰地了解{{common.appName}}及相關第三方在權限方面的操作，從而更好地保護您的個人信息和隱私。我們將一如既往地致力於為您提供安全、便捷、優質的產品和服務體驗。'
  },

  privacy: {
    titleSuffix: '隱私政策',
    p0001: "{{common.appName}}隱私政策",
    p0002: "{{common.appName}}隱私政策",
    p0003: "更新日期：2025年10月21日",
    p0004: "《{{common.appName}}隱私政策》（以下稱“本政策”）適用於{{common.companyName}}（以下簡稱“我們”）推出的人工智能服務（以下簡稱“{{common.appName}}”或“本服務”）。您在使用本服務前，請仔細閱讀本政策，以了解我們處理您個人信息的詳情。",
    p0005: "除非本隱私政策另有說明，本隱私政策適用於我們提供的{{common.appName}}網頁、應用程序、小程序、供第三方網站和應用程序使用的軟件開發工具包（SDK）和應用程序編程接口（API）以及隨著技術發展出現的創新形態方式提供的產品和服務。如您使用我們公司向您提供的智能體的某項或某幾項服務，有其單獨的隱私政策的，則相應服務或產品適用相應隱私政策；如未設立單獨隱私政策的，則本政策同樣適用於該部分產品或服務。",
    p0006: "請您知悉，終端用戶訪問開發者使用我們的開放平台服務開發的下游系統或應用時，其被收集的個人信息的處理規則不在本隱私政策的說明範圍內，運營該應用的開發者作為該個人信息處理活動的處理者應當向終端用戶披露相關個人信息保護規則。",
    p0007: "當您使用或開啟相關功能或使用服務時，為實現功能、服務所必需，我們會收集、使用相關信息。除非是為實現業務功能或根據法律法規要求所必需的必要信息，您均可以拒絕提供且不影響其他功能或服務。我們將在隱私政策中逐項說明所要收集的信息。",
    p0008: "相機權限均不會默認開啟，只有經過您的明示授權才會在為實現特定功能或服務時使用，您也可以撤回授權。特別需要指出的是，即使經過您的授權，我們獲得了這些敏感權限，也不會在相關功能或服務不需要時而收集您的信息。具體請參見：應用權限申請與使用情況說明。",
    p0009: "下文將幫您詳細了解我們如何收集、使用、存儲、轉移（如適用）與保護個人信息；幫您了解查詢、複製、刪除、更正、撤回授權個人信息的方式。本政策與您使用我們的服務關係密切，我們建議您仔細閱讀並理解本政策全部內容，作出您認為適當的選擇，有關您個人信息權益的條款重要內容我們已用加粗形式提示，請特別關注。",
    p0010: "個人信息處理總則",
    p0011: "為保障您的知情權、決定權與個人信息權益，我們在此集中說明本服務涉及的個人信息處理核心規則。您可結合後續章節詳細了解具體場景：",
    p0012: "1. 處理目的",
    p0013: "我們處理您的個人信息主要用於以下目的：",
    p0014: "提供、維護和優化{{common.appName}}智能對話、賬號管理、付費服務等核心功能；",
    p0015: "履行國家法律法規關於網絡實名制、網絡安全、內容安全等法定義務；",
    p0016: "保障系統與賬號安全，防範欺詐、濫用及違法違規行為；",
    p0017: "在經嚴格去標識化且無法重新識別特定個人的前提下，用於大模型訓練、服務優化與統計分析；",
    p0018: "向您發送服務通知、身份驗證信息及經您同意的商業推廣信息。",
    p0019: "2. 處理方式",
    p0020: "我們通過加密傳輸（TLS/SSL）、訪問控制、去標識化、匿名化、日誌審計等技術和管理措施處理個人信息，確保數據安全，防止未經授權的訪問、洩露、篡改或丟失。",
    p0021: "3. 個人信息類型",
    p0022: "我們可能處理的個人信息包括但不限於：",
    p0023: "賬號信息：",
    p0024: "手機號碼、第三方賬號暱稱/頭像；",
    p0025: "身份認證信息：",
    p0026: "真實姓名、身份證件號碼（僅限實名認證場景）；",
    p0027: "輸入與輸出內容：您在對話中輸入的文本、圖片、文件，以及{{common.appName}}生成的響應內容；",
    p0028: "設備與日誌信息：",
    p0029: "IP地址、設備型號、操作系統版本、設備標識符（如AndroidID、IDFV）、網絡狀態、操作行為日誌、傳感器數據；",
    p0030: "支付信息：訂單號、交易金額、支付渠道、充值記錄；",
    p0031: "反饋與客服信息：問題描述、聯繫方式、溝通記錄、附件材料。",
    p0032: "4. 保存期限",
    p0033: "我們僅在實現處理目的所必需的最短期間內保存您的個人信息，具體如下：",
    p0034: "賬號信息：賬號存續期間；",
    p0035: "對話輸入與輸出：默認保留至您主動刪除或註銷賬號；",
    p0036: "網絡運行日誌：不少於6個月（依據《網絡安全法》第二十一條）；",
    p0037: "支付與財務信息：依據《會計法》《電子商務法》等規定保存不少於5年；",
    p0038: "您註銷賬號後，我們將對您的個人信息進行刪除或匿名化處理，法律法規另有規定的除外。",
    p0039: "5. 關於模型訓練的特別說明",
    p0040: "您的輸入內容及對應的輸出內容可能被用於{{common.appName}}大語言模型的優化與訓練，但前提是：",
    p0041: "已通過安全加密技術處理；",
    p0042: "已進行嚴格去標識化；",
    p0043: "無法重新識別到您或其他特定個人。",
    p0044: "您有權拒絕該用途。如您不同意我們將您的數據用於模型訓練，請通過本政策第九章所述聯繫方式提出，我們將停止將您的數據用於該目的。",
    p0045: "6. 您的權利",
    p0046: "根據《中華人民共和國個人信息保護法》，您依法享有以下權利：",
    p0047: "知情權與決定權；",
    p0048: "限制或拒絕他人對您個人信息的處理；",
    p0049: "查閱、複製您的個人信息；",
    p0050: "更正、補充不準確或不完整的個人信息；",
    p0051: "刪除您的個人信息；",
    p0052: "撤回已作出的授權同意；",
    p0053: "註銷賬號；",
    p0054: "要求將您的個人信息轉移至您指定的其他處理者（在技術可行範圍內）；",
    p0055: "對個人信息處理規則要求解釋說明；",
    p0056: "向監管部門投訴或提起訴訟。",
    p0057: "具體行使方式詳見本政策第六章。",
    p0058: "7. 第三方共享與委託處理",
    p0059: "除為提供服務所必需（如雲服務商、支付機構、實名認證機構、安全審計方）或履行法定義務外，我們不會向其他第三方共享您的個人信息。所有合作方均須簽署數據處理協議，並接受我們的安全監督。如涉及跨境傳輸，將另行徵得您的單獨同意。",
    p0060: "一、我們如何收集和使用您的個人信息",
    p0061: "賬號註冊、登錄、認證",
    p0062: "為保障您的個人空間使用安全，您需要註冊並登錄後方可正常使用相關服務。您在註冊和登錄時需要向我們提供您本人的手機號碼並設置登錄密碼，並且通過輸入驗證碼，以便我們對您的用戶身份進行核驗。手機號碼是履行國家法律法規關於網絡實名制要求的必要信息，如果您不提供手機號碼用於註冊、登錄，我們可能無法為您提供生成式人工智能技術服務。",
    p0063: "您可以使用第三方賬號登錄並使用{{common.appName}}，經過您的同意，我們將獲取您在第三方平台註冊的公開信息（頭像、暱稱以及您授權的其他信息），用於與{{common.appName}}賬號綁定，使您可以直接登錄並使用本產品和相關服務。",
    p0064: "在您使用{{common.appName}}開放平台的付費服務時，我們需要對您的身份進行認證。您可以選擇認證為個人賬號或者代表企業認證為企業賬號。根據相關法律法規，當您選擇認證為個人開發者時，我們可能收集您的真實身份信息（真實姓名、證件號碼、電話號碼及其他必要身份信息）以完成實名驗證；當您代表企業認證為企業開發者時，我們可能會收集您所在企業法定代表人、企業聯繫人的真實姓名以完成企業實名驗證。部分信息屬於個人敏感信息，您可以拒絕提供，如果拒絕提供您將可能無法獲得相關服務，但不影響其他功能與服務的正常使用。",
    p0065: "智能對話",
    p0066: "在您使用智能對話功能服務時，我們將收集您與{{common.appName}}進行交互過程中所輸入的內容（包括文本、圖片、文件），我們會對上述信息進行分析與計算，以便於更好地理解您的問題和上下文語境，從而為您提供更具有相關性的信息內容，以提供智能對話服務。",
    p0067: "當您主動拍攝時，我們會請求您授權相機權限。如您拒絕授權，將無法拍攝圖片信息，但不影響您使用{{common.appName}}的其他功能。當您使用搜索服務時，我們會自動接收您主動輸入的信息，以便向您自動提供實時搜索結果。",
    p0068: "在對話過程中，您可以對{{common.appName}}所輸出的內容進行反饋評價。我們將收集您的反饋信息，包括您主動提交的內容，以便不斷改進{{common.appName}}的輸出內容質量。如您拒絕我們收集和處理前述個人信息，請您謹慎輸入前述信息，但因此您可能會影響您正常使用{{common.appName}}提供的部分或全部功能。",
    p0069: "為向您提供連續、高質量的服務，在經安全加密技術處理、嚴格去標識化且無法重新識別特定個人的前提下，我們可能會將服務所收集的輸入內容及對應輸出的內容，用於{{common.appName}}服務質量的提升和優化。如您拒絕我們按照上述方式處理您的個人信息，可以通過本政策第九章的方式向我們反饋。",
    p0070: "付費充值",
    p0071: "您可以就付費服務對您認證賬號下的賬戶進行預充值，當您使用付費服務進行預充值時，我們會收集您的支付訂單和交易信息，以為您提供充值訂單的下單、支付、客服及售後等服務，並向您展示和提供具體的付費服務。",
    p0072: "支付服務",
    p0073: "為完成訂單支付，您可通過與我們合作的支付機構（包括支付寶、微信支付及其他頁面提供的支付方式）所提供的服務進行支付。我們會在您使用支付服務過程中收集您的賬號信息、訂單支付相關信息及其他法律要求的必要信息並與支付機構共享，以確認您的支付指令並幫助您完成支付。支付機構還可能自行或委託我們收集或驗證您的銀行卡（含儲蓄卡、信用卡）信息以及其他支付必要信息。",
    p0074: "意見反饋",
    p0075: "如您使用意見反饋功能服務時，我們會收集您的問題描述信息、證明材料附件、手機號碼、郵箱、聯繫人姓名，以了解您反饋的內容和需求。此類信息屬於意見反饋功能服務的必要信息。為了核實您的身份，明確您的需求和相關問題的處理方案，或幫助您解決其他問題，我們可能會使用您的手機號碼或郵箱。為了向您提供與您使用過程信息相關的意見反饋服務時，我們將會查詢您的使用信息，包括對話記錄、點讚記錄、問題反饋記錄。",
    p0076: "如您直接通過本政策第九章所述的方式與我們聯繫，提出意見反饋，進行投訴、申訴或諮詢{{common.appName}}的相關問題時，為了確保您的賬號與系統的安全，您需要向我們提供您的賬號信息，以便我們對您的用戶身份進行核驗，此類信息屬於用戶反饋中進行身份核驗的必要信息。在反饋、投訴或諮詢過程中，為了幫助您解決問題或記錄相關問題的處理方案及結果，您可能需要向我們提供相應的證明材料附件，系統可能會記錄您與我們之間的溝通記錄，以便能夠更好地幫您解決所諮詢的問題和改善服務質量。如您不提供上述信息，我們可能無法向您及時反饋諮詢的結果，但不影響您正常使用{{common.appName}}或服務。",
    p0077: "消息通知",
    p0078: "您知悉並同意，對於您在使用產品及/或服務的過程中提供的您的聯繫方式（例如：聯繫電話），我們在運營中可能會向其中的一種或多種發送多類通知，用於用戶消息告知、身份驗證、安全驗證、用戶使用體驗調研、爭議處理等用途；此外，我們也可能會向前述過程中收集的手機號碼以短信、電話的方式，為您提供服務、功能或活動等商業性信息，但請您放心，如您不願接受這些信息，您可以通過手機短信中提供的退訂方式進行退訂（如回覆“R”，具體參考短信提供的方式），也可以直接與我們聯繫進行退訂。",
    p0079: "運營與安全保障",
    p0080: "為了保障您的賬號安全和更好地為您提供優質的服務，我們會自動收集您在使用{{common.appName}}服務過程中產生的如下信息作為網絡日誌：",
    p0081: "為了保障軟件與服務的安全運行、運營的質量及效率，我們會收集您的硬件型號、操作系統版本號、設備標識符（Android如AndroidID、OAID，iOS如IDFV；不同的標識符在有效期、是否可由用戶重置以及獲取方式方面會有所不同）、IP 地址、軟件版本號、網絡接入方式、類型、狀態、網絡質量數據、操作、使用、服務日誌、設備傳感器數據（如加速度傳感器、陀螺儀傳感器）。",
    p0082: "為了預防惡意程序、保障運營質量及效率，我們可能會收集正在運行的進程信息、頁面的總體運行、使用情況與頻率、頁面崩潰情況、總體使用情況、性能數據。為了判斷賬戶及交易安全、進行身份驗證、識別違法違規情況、檢測及防範安全事件，並依法採取必要的記錄、分析、處置措施，我們可能使用您的賬戶信息、設備信息以及服務日誌信息。",
    p0083: "為了分析應用新增、激活、留存、性能等統計性指標，我們可能會調用剪切板對相關統計信息進行歸因分析。請您放心，在統計過程中，我們不會上傳您的任何隱私信息至我們的服務器。",
    p0084: "我們可能會使用上述網絡日誌信息以便我們統計{{common.appName}}的使用情況，進行問題排查，並通過數據統計進行運營分析、改進和優化產品交互體驗。",
    p0085: "收集、使用個人信息的其他規則",
    p0086: "請您了解，隨著我們業務的發展，可能會對功能和提供的服務有所調整變化。原則上，當新功能或服務與我們當前提供的功能或服務相關時，收集與使用的個人信息將與原處理目的具有直接或合理關聯。在與原處理目的無直接或合理關聯的場景下，我們收集、使用您的個人信息，會再次按照法律法規及國家標準的要求以頁面提示、交互流程、協議確認方式另行向您進行告知說明，並徵得您的同意。",
    p0087: "請您理解，在下列情形中，根據法律法規及相關國家標準，我們收集和使用您的個人信息不必事先徵得您的授權同意：",
    p0088: "與我們履行法律法規規定的義務所必需的；",
    p0089: "與國家安全、國防安全直接相關的；",
    p0090: "維護公共安全、公共衛生、重大公共利益所必需的；",
    p0091: "與刑事偵查、起訴、審判和判決執行等直接相關的；",
    p0092: "出於維護您或他人的生命、財產等重大合法權益所必需但又很難得到本人授權同意的；",
    p0093: "您自行向社會公眾公開的個人信息；",
    p0094: "根據個人信息主體要求簽訂和履行合同所必需的；",
    p0095: "從合法公開披露的信息中收集的您的個人信息的，如合法的新聞報道、政府信息公開等渠道；",
    p0096: "為開展合法的新聞報道所必需的；",
    p0097: "法律法規規定的其他情形。",
    p0098: "特別提示您注意，如信息無法單獨或結合其他信息識別到您的個人身份，其不屬於法律意義上您的個人信息；當您的信息可以單獨或結合其他信息識別到您的個人身份時，或我們將無法與任何特定個人信息建立聯繫的數據與其他您的個人信息結合使用時，這些信息在結合使用期間，將作為您的個人信息按照本隱私政策處理與保護。",
    p0099: "二、我們如何使用Cookie等同类技術",
    p0100: "Cookie技術的使用",
    p0101: "我們會通過cookies收集和使用您的信息，並將該等信息儲存為日誌信息。我們使用自己的cookies，目的是用於以下用途：",
    p0102: "記住您的身份。例如：cookies有助於我們辨認您作為我們的註冊用戶的身份，或保存您向我們提供的其他信息；",
    p0103: "分析您使用我們服務的情況。例如，我們可利用cookies來了解您使用我們的服務進行什麼活動； 我們為上述目的使用cookies的同時，可能將通過cookies收集的非個人身份信息，經統計加工後提供給或其他合作夥伴，用於分析用戶如何使用我們的服務。",
    p0104: "Cookie同類技術的使用",
    p0105: "我們會使用的Cookie同類技術包括：網站信標和像素標籤。我們使用上述同類技術的目的是了解您的產品或服務偏好並改善客戶服務。",
    p0106: "Cookie的清除",
    p0107: "大多數瀏覽器均為用戶提供了清除瀏覽器緩存數據的功能，您可以在瀏覽器設置功能中進行相應的數據清除操作。如您進行清除，因為這些修改，您可能無法使用依賴於cookies的服務或相應功能。",
    p0108: "三、我們如何委託處理、共享、轉讓、公開披露您的個人信息",
    p0109: "數據共享的原則",
    p0110: "合法原則： 與合作方合作過程中涉及數據使用活動的，必須具有合法目的、符合法定的合法性基礎。如果合作方使用信息不再符合合法原則，則其不應再使用您的個人信息，或在獲得相應合法性基礎後再行使用。",
    p0111: "正當與最小必要原則： 數據使用必須具有正當目的，且應以達成目的必要為限。",
    p0112: "安全審慎原則： 我們將審慎評估合作方使用數據的目的，對這些合作方的安全保障能力進行綜合評估，並要求其遵循合作法律協議。我們會對合作方獲取信息的軟件工具開發包（SDK）、應用程序編程接口（API）進行嚴格的安全監測，以保護數據安全。",
    p0113: "對於委託處理個人信息的場景，我們會與受託合作方根據法律規定簽署相關處理協議，並對其個人信息使用活動進行監督。",
    p0114: "對於共同處理個人信息的場景，我們會與合作方根據法律規定簽署相關協議並約定各自的權利和義務，確保在使用相關個人信息的過程中遵守法律的相關規定、保護數據安全。",
    p0115: "實現功能或服務的數據使用",
    p0116: "當您使用{{common.appName}}中由我們的合作方提供的功能，或者由軟件服務提供商、智能設備提供商、系統服務提供商與我們聯合為您提供的服務時，我們可能會與其使用為實現業務目的所必需的信息。",
    p0117: "在您使用身份認證的功能或相關服務所需時，根據相關法律法規、安全保障要求可能需要完成實名認證以驗證您的身份。在實名認證的過程中，與我們合作的認證服務機構需要使用您的真實姓名、手機號碼。部分信息是個人敏感信息，拒絕上述使用將導致您無法完成身份認證，且可能無法獲得相關服務，但不會影響開放平台其他功能的正常使用。這些信息僅供實名認證及法律法規所規定的用途，未經您的明示授權，不會用作其他目的。",
    p0118: "實現推廣業務的數據使用",
    p0119: "為實現產品推廣以及相關分析服務，並優化與提升推廣的有效觸達率，產品的推廣方或提供推廣以及相關分析服務的合作方可能需要使用去標識化或匿名化後的設備、網絡、渠道信息以及轉化數據等。",
    p0120: "推廣合作方可能將上述信息與其合法獲取的其他數據相結合，以優化推廣效果，我們會要求其對信息的使用遵循合法、正當、必要原則，保障用戶合法權利不受侵犯。",
    p0121: "實現安全與分析統計而提供信息",
    p0122: "保障使用安全：我們非常重視賬號、服務及內容安全。為保障您和其他用戶的賬號與財產安全，使您和我們的正常合法權益免受不法侵害，我們的合作方可能會使用必要的設備、賬號及日誌信息。",
    p0123: "分析產品情況：為分析我們產品的使用和表現情況，我們的合作方可能需要使用該產品使用情況（崩潰、閃退）、設備標識信息、應用總體安裝使用情況等信息。",
    p0124: "轉移",
    p0125: "隨著我們業務的持續發展，我們將有可能進行合併、收購、資產轉讓，您的個人信息有可能因此而被轉移。在發生前述變更時，我們將按照法律法規及不低於本隱私政策所載明的安全標準要求繼受方繼續履行個人信息處理者的義務，若繼受方變更原先的處理目的、處理方式的，我們將要求繼受方重新徵得您的授權同意。",
    p0126: "公開",
    p0127: "我們不會公開您的個人信息，除非遵循國家法律法規規定或者獲得您的同意。我們公開您的個人信息會採用符合行業內標準的安全保護措施。",
    p0128: "在法律、法律程序、訴訟或政府主管部門強制性要求的情況下，我們可能會公開披露您的個人信息。",
    p0129: "如果我們確定您出現違反法律法規或嚴重違反本產品相關協議規則的情況，或為保護本產品及其關聯公司用戶或公眾的人身財產安全免遭侵害，我們可能依據法律法規或本產品相關協議規則披露關於您的個人信息，包括相關違規行為以及本產品已對您採取的措施。",
    p0130: "委託處理、共享、轉讓、公開披露個人信息時事先徵得授權同意的例外",
    p0131: "以下情形中，委託處理、共享、轉讓、公開披露您的個人信息無需事先徵得您的授權同意：",
    p0132: "我們履行法律法規規定的義務所必需的；",
    p0133: "與國家安全、國防安全直接相關的；",
    p0134: "維護公共安全、公共衛生、重大公共利益所必需的；",
    p0135: "刑事偵查、起訴、審判和判決執行等所必需的；",
    p0136: "出於維護您或他人的生命、財產等重大合法權益所必需但又很難得到本人授權同意的；",
    p0137: "您自行向社會公眾公開的個人信息；",
    p0138: "根據個人信息主體要求簽訂和履行合同所必需的；",
    p0139: "從合法公開披露的信息中收集的您的個人信息的，如合法的新聞報道、政府信息公開等渠道；",
    p0140: "為開展合法的新聞報道所必需的；",
    p0141: "法律法規規定的其他情形。",
    p0142: "請您知悉：根據法律規定，委託處理、共享、轉讓及公開披露經匿名化處理的個人信息的，不屬於個人信息的對外委託處理、共享、轉讓及公開披露的處理行為，對此類數據的保存及處理將無需另行向您通知並徵得您的同意。",
    p0143: "四、我們如何保護您的個人信息",
    p0144: "用戶的隱私和個人信息保護",
    p0145: "我們非常重視用戶的隱私和個人信息保護，也會採取合理的措施保護用戶的個人信息。除法律法規規定或本政策另有約定的情形外，我們將運用各種安全技術和程序建立完善的管理制度來保護您的個人信息，以免遭受未經授權的訪問、使用或披露。未經用戶許可我們不會向第三方公開、透露用戶個人信息，我們會對相關信息採用專業加密存儲與傳輸方式，保障用戶個人信息的安全。",
    p0146: "數據安全措施",
    p0147: "我們已採用符合業界標準的安全防護措施，包括建立合理的制度規範、安全技術來防止您的個人信息遭到未經授權的訪問使用、修改，避免數據的損壞或丟失。",
    p0148: "我們已採取一切合理可行的措施，確保未收集無關的個人信息。我們只會在達成本政策所述目的所需的期限內保留您的個人信息，除非需要延長保留期或受到法律的允許。",
    p0149: "互聯網並非絕對安全的環境，而且電子郵件、即時通訊、及與其他用戶的交流方式並未加密，我們強烈建議您不要通過此類方式發送個人信息。請使用複雜密碼，協助我們保證您的賬號安全。",
    p0150: "在不幸發生個人信息安全事件後，我們將按照法律法規的要求，及時向您告知：安全事件發生的原因、可能造成的危害、涉及個人信息的種類、我們已採取或將要採取的處置措施、您可自主防範和降低風險的建議和可採取的措施等。我們將及時將事件相關情況以電子郵件、短信、電話、發送通知等方式告知您，難以逐一告知個人信息主體時，我們會採取合理、有效的方式發佈公告。同時，我們還將按照監管部門要求，主動上報個人信息安全事件的處置情況。請您知悉，根據可適用法律法規的規定，如採取措施能夠有效避免信息洩露、篡改、丟失造成危害的，我們可以不向您進行告知。",
    p0151: "五、我們如何存儲您的個人信息",
    p0152: "存儲信息的地點",
    p0153: "{{common.appName}}遵守法律法規的規定，收集的有關您的信息和資料將保存在中華人民共和國境內大陸地區{{common.appName}}的服務器上。以下情形除外：",
    p0154: "法律法規有明確規定；",
    p0155: "獲得您的明確授權；",
    p0156: "您通過互聯網進行跨境交易等個人主動行為。",
    p0157: "存儲信息的期限",
    p0158: "我們僅在為提供{{common.appName}}服務之目的所必需的期間內保留您的個人信息：例如：",
    p0159: "手機號碼：當您使用手機號碼註冊登錄時，我們需要持續保留您的手機號碼，以便於向您提供正常的服務、應對您可能的查詢和客訴，並保障您的賬號和系統安全。",
    p0160: "您的付費充值等相關信息，在您未撤回、刪除或未註銷賬號期間，我們會保留相關信息用於向您提供持續的業務功能。",
    p0161: "如果您註銷賬號、主動刪除個人信息或超出必要的期限後，我們將對您的個人信息進行刪除或匿名化處理，但以下情況除外：",
    p0162: "遵從法律法規有關信息留存的要求（例如：《網絡安全法》規定：採取監測、記錄網絡運行狀態、網絡安全事件的技術措施，並按照規定留存相關的網絡日誌不少於六個月）。",
    p0163: "出於財務、審計、爭議解決等目的需要合理延長期限的。",
    p0164: "當本服務發生停止運營的情形時，{{common.appName}}將採取包括發送通知和公告形式通知您，並在法律法規要求的期限內刪除服務器中留存的您的個人信息。",
    p0165: "六、您如何實現管理您個人信息的權利",
    p0166: "您的個人信息權利",
    p0167: "按照中國相關的法律、法規、標準，您在個人信息處理活動中享有若干權利，具體包括：",
    p0168: "您對個人信息處理享有知情權、決定權，有權限制或者拒絕他人對您個人信息進行處理，法律、行政法規另有規定的除外；",
    p0169: "您有權向個人信息處理者查閱、複製您的個人信息，法律另有規定情形的除外；",
    p0170: "您有權請求將您的個人信息轉移至您指定的個人信息處理者；",
    p0171: "您發現您的個人信息不準確或不完整的，有權請求個人信息處理者更正、補充；",
    p0172: "您有權請求刪除您的個人信息；",
    p0173: "您有權要求個人信息處理者對其個人信息處理規則進行解釋說明。",
    p0174: "行使權利的方式",
    p0175: "我們保障您對自己的個人信息行使前述權利，並為您提供相關操作路徑，具體地，您可以參考以下步驟進行相關操作：",
    p0176: "改變或撤回授權範圍",
    p0177: "您可以在設備本身的操作系統中，關閉相機權限，改變同意範圍或撤回您的授權。",
    p0178: "具體地，您可以通過以下方式進行操作：",
    p0179: "安卓：系統設置 → 應用設置 → 應用管理 → 搜索或查找{{common.appName}} → 權限管理 → 選擇對應權限 → 關閉",
    p0180: "iOS：系統設置 → {{common.appName}} → 選擇對應權限 → 關閉",
    p0181: "請您知悉，具體的關閉方式可能因您使用設備型號、系統版本的不同而不盡相同。請您理解，當您執行上述操作後，我們將無法繼續為您提供撤回同意或授權所對應的服務，我們將不再收集與這些權限相關的信息，但不會影響此前基於您的授權而開展的個人信息處理。",
    p0182: "查閱、複製、更正、補充、刪除您的個人信息",
    p0183: "您可以通過如下方式查閱、複製、更正、補充或刪除您的個人信息：",
    p0184: "查閱/更正/補充賬號信息：點擊頭像賬號區域，進行操作",
    p0185: "查閱/刪除歷史對話：展開對話框左側 → 選擇歷史對話 → 刪除，或點擊頭像賬號區域 → 選擇“刪除所有對話”",
    p0186: "複製/修改歷史對話：選擇對話框內的輸入內容 → 複製/修改",
    p0188: "由於應用版本的升級和功能的變動，上述具體的操作步驟可能不同，以應用內實際的操作步驟為準。除上述外，如果您或其他有權主體對相關法律法規賦予您的個人信息權利的行使，有任何主張、要求或者疑問，您可以通過本政策第九章的聯繫方式與我們聯繫，我們將盡快審核所涉問題，並在驗證您的用戶身份後的十五個工作日內回覆。對於那些無端重複、需要過多技術手段（例如，需要開發新系統或從根本上改變現行慣例）、給他人合法權益帶來風險或者非常不切實際（例如，涉及備份磁帶上存放的信息）的請求，{{common.appName}}可能會予以拒絕。",
    p0189: "逝者的個人信息保護",
    p0190: "我們會持續確保我們的用戶信息安全無虞。若{{common.appName}}的用戶不幸去世，其近親屬（以下簡稱“逝者近親屬”）為了自身的合法、正當利益，可通過本隱私政策第九章列明的方式，與我們取得聯繫，在不違反逝者生前安排且不侵害他人和公眾正當利益的前提下，對逝者的相應個人信息行使查閱、複製、更正、刪除等權利。為了充分保護逝者的個人信息權益，申請行使該等權利的逝者近親屬需要完成身份核驗手續，並承諾和保證逝者近親屬行使該等權利不違背逝者生前的安排，且行使權利的目的具有合法正當性。",
    p0191: "註銷賬號",
    p0192: "您有權根據《{{common.appName}}註銷須知》註銷您的賬號，您可以通過“主頁” → “個人信息” → “註銷賬號”或根據本政策第九章所述的方式聯繫我們進行賬號註銷。在您註銷賬號前，我們將驗證您的個人身份、安全狀態、財產結清情況、設備信息等。我們將會在收到您的申請後及時進行處理，並在十五個工作日或法律法規要求的時限內回覆您的請求。您知悉並理解，註銷賬號的行為是不可逆的行為，當您註銷賬號後，我們將刪除有關您的相關信息或進行匿名化處理，但法律法規及相關國家標準另有規定的除外。",
    p0193: "七、我們如何保護未成年人的個人信息",
    p0194: "{{common.appName}}主要服務成年人，但我們依然非常重視對未成年人個人信息的保護。",
    p0195: "若您是未滿18週歲的未成年人，在使用本產品及相關服務前，請在您的父母或其他監護人的監護、指導下共同閱讀並同意本隱私政策。我們不會主動收集未滿14週歲的未成年人（兒童）的個人信息。如果我們發現或接到反饋，在未事先獲得監護人同意的情況下自動收集了兒童的個人信息，則會設法盡快刪除相關信息。",
    p0196: "若您是未成年人的父母或監護人，如您對本政策所述相關事宜有任何疑問、意見、建議或投訴、舉報需求，請通過第九章所述方式與我們進行反饋。",
    p0197: "八、我們如何更新本政策",
    p0198: "為給您提供更好的服務，{{common.appName}}將不時更新與變化，我們會適時對本政策進行修訂，這些修訂構成本政策的一部分。",
    p0199: "本政策更新後，我們會在{{common.appName}}網站發出更新版本，通過新版本公告等方式再次提醒您閱讀更新後的隱私政策，以便您及時了解本政策的最新版本。如果您不同意本政策，或對本政策修改、更新的內容有異議，您可以選擇停止使用本服務或者註銷賬號。但請您知悉，您賬號註銷之前、停止使用本服務之前的行為和活動仍受本政策的約束。",
    p0200: "對於會導致您在本個人信息保護規則項下權利的實質減損的重大變更，我們還會提供更為顯著的通知（我們會通過包括但不限於電子郵件、短信或在瀏覽頁面做特別提示等方式，說明本政策的具體變更部分）。",
    p0201: "我們鼓勵您在使用我們產品與/或服務的過程中查閱本政策。",
    p0202: "九、如何聯繫我們",
    p0203: "如您在使用{{common.appName}}的過程中對本政策或對您的個人信息有任何疑問或建議，請通過以下聯繫方式與我們聯繫：",
    p0204: "網絡自助投訴反饋入口：登錄產品界面 → 點擊“聯繫我們”按鈕",
    p0205: "聯繫郵箱：{{common.contactEmail}}",
    p0206: "{{common.companyName}}",
    p0207: "我們可能需要您提交有效聯繫方式和書面請求及相關證據，我們會在驗證您的身份後處理您的請求。我們將盡快審核所涉問題，並在驗證您的用戶身份後的十五個工作日內回覆。",
  },

  user: {
    titleSuffix: '用戶協議',
    u0001: "{{common.appName}}隱私政策與用戶協議",
    u0003: "{{common.appName}}隱私政策與用戶協議",
    u0004: "更新日期：2026年6月30日",
    u0005: "親愛的用戶，歡迎您使用{{common.appName}}產品及服務！{{common.appName}}產品及服務由{{common.companyName}}（以下簡稱“我們”）負責運營。本文件包含《{{common.appName}}隱私政策》（以下稱“本政策”）與《{{common.appName}}用戶協議》（以下稱“本協議”），共同適用於我們推出的人工智能服務（以下稱“{{common.appName}}”或“本服務”），包括網頁、應用程序、小程序、SDK、API 及隨技術發展出現的其他形態。",
    u0006: "在使用本服務前，請您務必仔細閱讀並理解本文件全部內容。您在使用某一特定功能時，針對該功能可能另有單獨協議或業務規則（以下稱“具體協議”）；本文件與具體協議衝突的，以具體協議為準。所有前述條款構成本文件不可分割的組成部分（通稱“全部協議”），具有同等法律效力。",
    u0007: "我們特別提醒您在使用本服務前認真閱讀（未滿18週歲的未成年人應在法定監護人陪同下閱讀）、充分理解全部條款，尤其是加粗顯示及個人信息相關條款。當您點擊確認、勾選同意或實際使用本服務時，即表示您已接受全部協議約束。若您不同意任一內容，請停止使用本服務。",
    u0008: "下文將說明我們如何收集、使用、存儲、共享與保護個人信息，以及您使用本服務應遵守的規則。有關個人信息權益的重要條款已加粗提示，請特別關注。終端用戶訪問開發者基於我們開放平台開發的下游應用時，其個人信息處理規則由該應用開發者另行向用戶披露。",
    u0009: "相機等敏感權限均不會默認開啟，僅在經您明示授權且為實現特定功能所必需時使用，您也可隨時撤回授權。",
    u0010: "個人信息處理總則",
    u0011: "為保障您的知情權、決定權與個人信息權益，我們在此集中說明本服務涉及的個人信息處理核心規則。您可結合後續章節詳細了解具體場景：",
    u0012: "1. 處理目的",
    u0013: "我們處理您的個人信息主要用於以下目的：",
    u0014: "提供、維護和優化{{common.appName}}智能對話、賬號管理、付費服務等核心功能；",
    u0015: "履行國家法律法規關於網絡實名制、網絡安全、內容安全等法定義務；",
    u0016: "保障系統與賬號安全，防範欺詐、濫用及違法違規行為；",
    u0017: "在經嚴格去標識化且無法重新識別特定個人的前提下，用於大模型訓練、服務優化與統計分析；",
    u0018: "向您發送服務通知、身份驗證信息及經您同意的商業推廣信息。",
    u0019: "2. 處理方式",
    u0020: "我們通過加密傳輸（TLS/SSL）、訪問控制、去標識化、匿名化、日誌審計等技術和管理措施處理個人信息，確保數據安全，防止未經授權的訪問、洩露、篡改或丟失。",
    u0021: "3. 個人信息類型",
    u0022: "我們可能處理的個人信息包括但不限於：",
    u0023: "賬號信息：",
    u0024: "手機號碼、第三方賬號暱稱/頭像；",
    u0025: "身份認證信息：",
    u0026: "真實姓名、身份證件號碼（僅限實名認證場景）；",
    u0027: "輸入與輸出內容：您在對話中輸入的文本、圖片、文件，以及{{common.appName}}生成的響應內容；",
    u0028: "設備與日誌信息：",
    u0029: "IP地址、設備型號、操作系統版本、設備標識符（如AndroidID、IDFV）、網絡狀態、操作行為日誌、傳感器數據；",
    u0030: "支付信息：訂單號、交易金額、支付渠道、充值記錄；",
    u0031: "反饋與客服信息：問題描述、聯繫方式、溝通記錄、附件材料。",
    u0032: "4. 保存期限",
    u0033: "我們僅在實現處理目的所必需的最短期間內保存您的個人信息，具體如下：",
    u0034: "賬號信息：賬號存續期間；",
    u0035: "對話輸入與輸出：默認保留至您主動刪除或註銷賬號；",
    u0036: "網絡運行日誌：不少於6個月（依據《網絡安全法》第二十一條）；",
    u0037: "支付與財務信息：依據《會計法》《電子商務法》等規定保存不少於5年；",
    u0038: "您註銷賬號後，我們將對您的個人信息進行刪除或匿名化處理，法律法規另有規定的除外。",
    u0039: "5. 關於模型訓練的特別說明",
    u0040: "您的輸入內容及對應的輸出內容可能被用於{{common.appName}}大語言模型的優化與訓練，但前提是：",
    u0041: "已通過安全加密技術處理；",
    u0042: "已進行嚴格去標識化；",
    u0043: "無法重新識別到您或其他特定個人。",
    u0044: "您有權拒絕該用途。如您不同意我們將您的數據用於模型訓練，請通過第十六節列明的聯繫方式提出，我們將停止將您的數據用於該目的。",
    u0045: "6. 您的權利",
    u0046: "根據《中華人民共和國個人信息保護法》，您依法享有以下權利：",
    u0047: "知情權與決定權；",
    u0048: "限制或拒絕他人對您個人信息的處理；",
    u0049: "查閱、複製您的個人信息；",
    u0050: "更正、補充不準確或不完整的個人信息；",
    u0051: "刪除您的個人信息；",
    u0052: "撤回已作出的授權同意；",
    u0053: "註銷賬號；",
    u0054: "要求將您的個人信息轉移至您指定的其他處理者（在技術可行範圍內）；",
    u0055: "對個人信息處理規則要求解釋說明；",
    u0056: "向監管部門投訴或提起訴訟。",
    u0057: "具體行使方式詳見第六節。",
    u0058: "7. 第三方共享與委託處理",
    u0059: "除為提供服務所必需或履行法定義務外，我們不會向第三方共享您的個人信息；具體共享原則、第三方 SDK 目錄及委託處理規則詳見",
    u0060: "第三節",
    u0061: "。",
    u0062: "一、我們如何收集和使用您的個人信息",
    u0063: "賬號註冊、登錄、認證",
    u0064: "為保障您的個人空間使用安全，您需要註冊並登錄後方可正常使用相關服務。您在註冊和登錄時需要向我們提供您本人的手機號碼並設置登錄密碼，並且通過輸入驗證碼，以便我們對您的用戶身份進行核驗。手機號碼是履行國家法律法規關於網絡實名制要求的必要信息，如果您不提供手機號碼用於註冊、登錄，我們可能無法為您提供生成式人工智能技術服務。",
    u0065: "您可以使用第三方賬號登錄並使用{{common.appName}}，經過您的同意，我們將獲取您在第三方平台註冊的公開信息（頭像、暱稱以及您授權的其他信息），用於與{{common.appName}}賬號綁定，使您可以直接登錄並使用本產品和相關服務。",
    u0066: "在您使用{{common.appName}}開放平台的付費服務時，我們需要對您的身份進行認證。您可以選擇認證為個人賬號或者代表企業認證為企業賬號。根據相關法律法規，當您選擇認證為個人開發者時，我們可能收集您的真實身份信息（真實姓名、證件號碼、電話號碼及其他必要身份信息）以完成實名驗證；當您代表企業認證為企業開發者時，我們可能會收集您所在企業法定代表人、企業聯繫人的真實姓名以完成企業實名驗證。部分信息屬於個人敏感信息，您可以拒絕提供，如果拒絕提供您將可能無法獲得相關服務，但不影響其他功能與服務的正常使用。",
    u0067: "智能對話",
    u0068: "在您使用智能對話功能服務時，我們將收集您與{{common.appName}}進行交互過程中所輸入的內容（包括文本、圖片、文件），我們會對上述信息進行分析與計算，以便於更好地理解您的問題和上下文語境，從而為您提供更具有相關性的信息內容，以提供智能對話服務。",
    u0069: "當您主動拍攝時，我們會請求您授權相機權限。如您拒絕授權，將無法拍攝圖片信息，但不影響您使用{{common.appName}}的其他功能。當您使用搜索服務時，我們會自動接收您主動輸入的信息，以便向您自動提供實時搜索結果。",
    u0070: "在對話過程中，您可以對{{common.appName}}所輸出的內容進行反饋評價。我們將收集您的反饋信息，包括您主動提交的內容，以便不斷改進{{common.appName}}的輸出內容質量。如您拒絕我們收集和處理前述個人信息，請您謹慎輸入前述信息，但因此您可能會影響您正常使用{{common.appName}}提供的部分或全部功能。",
    u0071: "為向您提供連續、高質量的服務，在經安全加密技術處理、嚴格去標識化且無法重新識別特定個人的前提下，我們可能會將服務所收集的輸入內容及對應輸出的內容，用於{{common.appName}}服務質量的提升和優化。如您拒絕我們按照上述方式處理您的個人信息，可以通過第十六節列明的方式向我們反饋。",
    u0072: "付費充值",
    u0073: "您可以就付費服務對您認證賬號下的賬戶進行預充值，當您使用付費服務進行預充值時，我們會收集您的支付訂單和交易信息，以為您提供充值訂單的下單、支付、客服及售後等服務，並向您展示和提供具體的付費服務。",
    u0074: "支付服務",
    u0075: "為完成訂單支付，您可通過與我們合作的支付機構（包括支付寶、微信支付及其他頁面提供的支付方式）所提供的服務進行支付。我們會在您使用支付服務過程中收集您的賬號信息、訂單支付相關信息及其他法律要求的必要信息並與支付機構共享，以確認您的支付指令並幫助您完成支付。支付機構還可能自行或委託我們收集或驗證您的銀行卡（含儲蓄卡、信用卡）信息以及其他支付必要信息。",
    u0076: "意見反饋",
    u0077: "如您使用意見反饋功能服務時，我們會收集您的問題描述信息、證明材料附件、手機號碼、郵箱、聯繫人姓名，以了解您反饋的內容和需求。此類信息屬於意見反饋功能服務的必要信息。為了核實您的身份，明確您的需求和相關問題的處理方案，或幫助您解決其他問題，我們可能會使用您的手機號碼或郵箱。為了向您提供與您使用過程信息相關的意見反饋服務時，我們將會查詢您的使用信息，包括對話記錄、點讚記錄、問題反饋記錄。",
    u0078: "如您直接通過第十六節列明的方式與我們聯繫，提出意見反饋，進行投訴、申訴或諮詢{{common.appName}}的相關問題時，為了確保您的賬號與系統的安全，您需要向我們提供您的賬號信息，以便我們對您的用戶身份進行核驗，此類信息屬於用戶反饋中進行身份核驗的必要信息。在反饋、投訴或諮詢過程中，為了幫助您解決問題或記錄相關問題的處理方案及結果，您可能需要向我們提供相應的證明材料附件，系統可能會記錄您與我們之間的溝通記錄，以便能夠更好地幫您解決所諮詢的問題和改善服務質量。如您不提供上述信息，我們可能無法向您及時反饋諮詢的結果，但不影響您正常使用{{common.appName}}或服務。",
    u0079: "消息通知",
    u0080: "您知悉並同意，對於您在使用產品及/或服務的過程中提供的您的聯繫方式（例如：聯繫電話），我們在運營中可能會向其中的一種或多種發送多類通知，用於用戶消息告知、身份驗證、安全驗證、用戶使用體驗調研、爭議處理等用途；此外，我們也可能會向前述過程中收集的手機號碼以短信、電話的方式，為您提供服務、功能或活動等商業性信息，但請您放心，如您不願接受這些信息，您可以通過手機短信中提供的退訂方式進行退訂（如回覆“R”，具體參考短信提供的方式），也可以直接與我們聯繫進行退訂。",
    u0081: "運營與安全保障",
    u0082: "為了保障您的賬號安全和更好地為您提供優質的服務，我們會自動收集您在使用{{common.appName}}服務過程中產生的如下信息作為網絡日誌：",
    u0083: "為了保障軟件與服務的安全運行、運營的質量及效率，我們會收集您的硬件型號、操作系統版本號、設備標識符（Android如AndroidID、OAID，iOS如IDFV；不同的標識符在有效期、是否可由用戶重置以及獲取方式方面會有所不同）、IP 地址、軟件版本號、網絡接入方式、類型、狀態、網絡質量數據、操作、使用、服務日誌、設備傳感器數據（如加速度傳感器、陀螺儀傳感器）。",
    u0084: "為了預防惡意程序、保障運營質量及效率，我們可能會收集正在運行的進程信息、頁面的總體運行、使用情況與頻率、頁面崩潰情況、總體使用情況、性能數據。為了判斷賬戶及交易安全、進行身份驗證、識別違法違規情況、檢測及防範安全事件，並依法採取必要的記錄、分析、處置措施，我們可能使用您的賬戶信息、設備信息以及服務日誌信息。",
    u0085: "為了分析應用新增、激活、留存、性能等統計性指標，我們可能會調用剪切板對相關統計信息進行歸因分析。請您放心，在統計過程中，我們不會上傳您的任何隱私信息至我們的服務器。",
    u0086: "我們可能會使用上述網絡日誌信息以便我們統計{{common.appName}}的使用情況，進行問題排查，並通過數據統計進行運營分析、改進和優化產品交互體驗。",
    u0087: "收集、使用個人信息的其他規則",
    u0088: "請您了解，隨著我們業務的發展，可能會對功能和提供的服務有所調整變化。原則上，當新功能或服務與我們當前提供的功能或服務相關時，收集與使用的個人信息將與原處理目的具有直接或合理關聯。在與原處理目的無直接或合理關聯的場景下，我們收集、使用您的個人信息，會再次按照法律法規及國家標準的要求以頁面提示、交互流程、協議確認方式另行向您進行告知說明，並徵得您的同意。",
    u0089: "請您理解，在下列情形中，根據法律法規及相關國家標準，我們收集和使用您的個人信息不必事先徵得您的授權同意：",
    u0090: "與我們履行法律法規規定的義務所必需的；",
    u0091: "與國家安全、國防安全直接相關的；",
    u0092: "維護公共安全、公共衛生、重大公共利益所必需的；",
    u0093: "與刑事偵查、起訴、審判和判決執行等直接相關的；",
    u0094: "出於維護您或他人的生命、財產等重大合法權益所必需但又很難得到本人授權同意的；",
    u0095: "您自行向社會公眾公開的個人信息；",
    u0096: "根據個人信息主體要求簽訂和履行合同所必需的；",
    u0097: "從合法公開披露的信息中收集的您的個人信息的，如合法的新聞報道、政府信息公開等渠道；",
    u0098: "為開展合法的新聞報道所必需的；",
    u0099: "法律法規規定的其他情形。",
    u0100: "特別提示您注意，如信息無法單獨或結合其他信息識別到您的個人身份，其不屬於法律意義上您的個人信息；當您的信息可以單獨或結合其他信息識別到您的個人身份時，或我們將無法與任何特定個人信息建立聯繫的數據與其他您的個人信息結合使用時，這些信息在結合使用期間，將作為您的個人信息按照本隱私政策處理與保護。",
    u0101: "二、我們如何使用Cookie等同类技術",
    u0102: "Cookie技術的使用",
    u0103: "我們會通過cookies收集和使用您的信息，並將該等信息儲存為日誌信息。我們使用自己的cookies，目的是用於以下用途：",
    u0104: "記住您的身份。例如：cookies有助於我們辨認您作為我們的註冊用戶的身份，或保存您向我們提供的其他信息；",
    u0105: "分析您使用我們服務的情況。例如，我們可利用cookies來了解您使用我們的服務進行什麼活動； 我們為上述目的使用cookies的同時，可能將通過cookies收集的非個人身份信息，經統計加工後提供給或其他合作夥伴，用於分析用戶如何使用我們的服務。",
    u0106: "Cookie同類技術的使用",
    u0107: "我們會使用的Cookie同類技術包括：網站信標和像素標籤。我們使用上述同類技術的目的是了解您的產品或服務偏好並改善客戶服務。",
    u0108: "Cookie的清除",
    u0109: "大多數瀏覽器均為用戶提供了清除瀏覽器緩存數據的功能，您可以在瀏覽器設置功能中進行相應的數據清除操作。如您進行清除，因為這些修改，您可能無法使用依賴於cookies的服務或相應功能。",
    u0110: "三、我們如何委託處理、共享、轉讓、公開披露您的個人信息",
    u0111: "數據共享的原則",
    u0112: "合法原則： 與合作方合作過程中涉及數據使用活動的，必須具有合法目的、符合法定的合法性基礎。如果合作方使用信息不再符合合法原則，則其不應再使用您的個人信息，或在獲得相應合法性基礎後再行使用。",
    u0113: "正當與最小必要原則： 數據使用必須具有正當目的，且應以達成目的必要為限。",
    u0114: "安全審慎原則： 我們將審慎評估合作方使用數據的目的，對這些合作方的安全保障能力進行綜合評估，並要求其遵循合作法律協議。我們會對合作方獲取信息的軟件工具開發包（SDK）、應用程序編程接口（API）進行嚴格的安全監測，以保護數據安全。",
    u0115: "對於委託處理個人信息的場景，我們會與受託合作方根據法律規定簽署相關處理協議，並對其個人信息使用活動進行監督。",
    u0116: "對於共同處理個人信息的場景，我們會與合作方根據法律規定簽署相關協議並約定各自的權利和義務，確保在使用相關個人信息的過程中遵守法律的相關規定、保護數據安全。",
    u0117: "第三方 SDK 目錄",
    u0118: "{{common.appName}} 中部分功能由第三方 SDK 提供，這些 SDK 可能會收集您的個人信息。我們已對合作 SDK 進行安全評估，並",
    u0119: "僅在您點擊同意本隱私政策後",
    u0120: "才會初始化相關 SDK 並開始收集信息。我們要求第三方 SDK 遵循合法、正當、必要原則，並採取加密傳輸等安全措施保護您的個人信息。",
    u0121: "特別說明：",
    u0122: "Android 端為實現設備識別、保障應用基礎功能運行及安全防範，應用會通過移動安全聯盟（MSA）設備標識 SDK 獲取 OAID、VAID、AAID 等設備匿名標識符。上述標識符由設備系統或 MSA SDK 在本地讀取，",
    u0123: "僅在您同意本隱私政策後",
    u0124: "才會被調用；我們不會超出本政策聲明的目的和範圍使用這些信息。",
    u0125: "MSA 移動安全聯盟設備標識 SDK",
    u0126: "第三方名稱",
    u0127: "中國信息通信研究院（移動安全聯盟 MSA）",
    u0128: "使用目的",
    u0129: "獲取設備匿名標識符，用於保障應用基礎功能運行、設備識別、安全防範及統計分析",
    u0130: "收集的個人信息類型",
    u0131: "OAID（開放匿名設備標識符）、VAID（開發者匿名設備標識符）、AAID（應用匿名設備標識符）",
    u0132: "收集方式",
    u0133: "SDK 集成後，在您同意隱私政策後通過接口自動讀取設備系統提供的匿名標識信息",
    u0134: "第三方隱私政策",
    u0135: "http://www.msa-alliance.cn/col.jsp?id=122",
    u0136: "DCloud uni-app 開發框架 SDK",
    u0137: "第三方名稱",
    u0138: "數字天堂（北京）網絡技術有限公司",
    u0139: "使用目的",
    u0140: "提供應用運行基礎框架、啟動與隱私合規彈窗、應用更新等基礎能力；配合調用設備標識 SDK 以保障應用正常運行",
    u0141: "收集的個人信息類型",
    u0142: "設備型號、操作系統版本、設備標識符（含 OAID/VAID/AAID）、網絡狀態、應用版本信息",
    u0143: "收集方式",
    u0144: "APP 集成 uni-app 運行框架後，在您同意隱私政策後自動初始化並採集",
    u0145: "第三方隱私政策",
    u0146: "https://dcloud.io/license/appprivacy.html",
    u0147: "微信 Open SDK",
    u0148: "第三方名稱",
    u0149: "深圳市騰訊計算機系統有限公司",
    u0150: "使用目的",
    u0151: "實現微信賬號登錄、微信支付、微信分享功能",
    u0152: "收集的個人信息類型",
    u0153: "設備信息、網絡信息、微信賬號授權信息（頭像、暱稱等您授權的信息）",
    u0154: "收集方式",
    u0155: "您主動使用微信登錄、支付或分享功能時，由 SDK 採集並傳輸",
    u0156: "第三方隱私政策",
    u0157: "微信隱私保護指引",
    u0158: "支付寶 SDK",
    u0159: "第三方名稱",
    u0160: "支付寶（中國）網絡技術有限公司",
    u0161: "使用目的",
    u0162: "實現支付寶支付功能",
    u0163: "收集的個人信息類型",
    u0164: "設備信息、網絡信息、交易訂單信息",
    u0165: "收集方式",
    u0166: "您主動選擇支付寶支付時，由 SDK 採集並傳輸",
    u0167: "第三方隱私政策",
    u0168: "https://opendocs.alipay.com/common/02khjf",
    u0169: "Apple 應用內購買 SDK（僅 iOS）",
    u0170: "第三方名稱",
    u0171: "Apple Inc.",
    u0172: "使用目的",
    u0173: "實現 iOS 端應用內購買與訂閱功能",
    u0174: "收集的個人信息類型",
    u0175: "Apple 賬號標識、交易憑證、設備信息",
    u0176: "收集方式",
    u0177: "您主動發起 iOS 內購時，由 Apple 系統 SDK 處理",
    u0178: "第三方隱私政策",
    u0179: "https://www.apple.com/legal/privacy/",
    u0180: "上述 SDK 如涉及向第三方傳輸個人信息，我們將督促其採用",
    u0181: "加密傳輸（TLS/SSL）",
    u0182: "等安全措施。如第三方 SDK 的個人信息處理規則發生變更，我們將及時更新本目錄。",
    u0183: "用戶同意與信息採集時機",
    u0184: "我們承諾：",
    u0185: "在您點擊同意本隱私政策（含用戶協議）之前，不會初始化第三方 SDK 或收集您的個人信息",
    u0186: "（法律法規另有規定的除外）。您可通過系統設置關閉相關權限，或聯繫我們撤回授權。",
    u0187: "實現功能或服務的數據使用",
    u0188: "當您使用{{common.appName}}中由我們的合作方提供的功能，或者由軟件服務提供商、智能設備提供商、系統服務提供商與我們聯合為您提供的服務時，我們可能會與其使用為實現業務目的所必需的信息。",
    u0189: "在您使用身份認證的功能或相關服務所需時，根據相關法律法規、安全保障要求可能需要完成實名認證以驗證您的身份。在實名認證的過程中，與我們合作的認證服務機構需要使用您的真實姓名、手機號碼。部分信息是個人敏感信息，拒絕上述使用將導致您無法完成身份認證，且可能無法獲得相關服務，但不會影響開放平台其他功能的正常使用。這些信息僅供實名認證及法律法規所規定的用途，未經您的明示授權，不會用作其他目的。",
    u0190: "實現推廣業務的數據使用",
    u0191: "為實現產品推廣以及相關分析服務，並優化與提升推廣的有效觸達率，產品的推廣方或提供推廣以及相關分析服務的合作方可能需要使用去標識化或匿名化後的設備、網絡、渠道信息以及轉化數據等。",
    u0192: "推廣合作方可能將上述信息與其合法獲取的其他數據相結合，以優化推廣效果，我們會要求其對信息的使用遵循合法、正當、必要原則，保障用戶合法權利不受侵犯。",
    u0193: "實現安全與分析統計而提供信息",
    u0194: "保障使用安全：我們非常重視賬號、服務及內容安全。為保障您和其他用戶的賬號與財產安全，使您和我們的正常合法權益免受不法侵害，我們的合作方可能會使用必要的設備、賬號及日誌信息。",
    u0195: "分析產品情況：為分析我們產品的使用和表現情況，我們的合作方可能需要使用該產品使用情況（崩潰、閃退）、設備標識信息、應用總體安裝使用情況等信息。",
    u0196: "轉移",
    u0197: "隨著我們業務的持續發展，我們將有可能進行合併、收購、資產轉讓，您的個人信息有可能因此而被轉移。在發生前述變更時，我們將按照法律法規及不低於本隱私政策所載明的安全標準要求繼受方繼續履行個人信息處理者的義務，若繼受方變更原先的處理目的、處理方式的，我們將要求繼受方重新徵得您的授權同意。",
    u0198: "公開",
    u0199: "我們不會公開您的個人信息，除非遵循國家法律法規規定或者獲得您的同意。我們公開您的個人信息會採用符合行業內標準的安全保護措施。",
    u0200: "在法律、法律程序、訴訟或政府主管部門強制性要求的情況下，我們可能會公開披露您的個人信息。",
    u0201: "如果我們確定您出現違反法律法規或嚴重違反本產品相關協議規則的情況，或為保護本產品及其關聯公司用戶或公眾的人身財產安全免遭侵害，我們可能依據法律法規或本產品相關協議規則披露關於您的個人信息，包括相關違規行為以及本產品已對您採取的措施。",
    u0202: "委託處理、共享、轉讓、公開披露個人信息時事先徵得授權同意的例外",
    u0203: "以下情形中，委託處理、共享、轉讓、公開披露您的個人信息無需事先徵得您的授權同意：",
    u0204: "我們履行法律法規規定的義務所必需的；",
    u0205: "與國家安全、國防安全直接相關的；",
    u0206: "維護公共安全、公共衛生、重大公共利益所必需的；",
    u0207: "刑事偵查、起訴、審判和判決執行等所必需的；",
    u0208: "出於維護您或他人的生命、財產等重大合法權益所必需但又很難得到本人授權同意的；",
    u0209: "您自行向社會公眾公開的個人信息；",
    u0210: "根據個人信息主體要求簽訂和履行合同所必需的；",
    u0211: "從合法公開披露的信息中收集的您的個人信息的，如合法的新聞報道、政府信息公開等渠道；",
    u0212: "為開展合法的新聞報道所必需的；",
    u0213: "法律法規規定的其他情形。",
    u0214: "請您知悉：根據法律規定，委託處理、共享、轉讓及公開披露經匿名化處理的個人信息的，不屬於個人信息的對外委託處理、共享、轉讓及公開披露的處理行為，對此類數據的保存及處理將無需另行向您通知並徵得您的同意。",
    u0215: "四、我們如何保護您的個人信息",
    u0216: "用戶的隱私和個人信息保護",
    u0217: "我們非常重視用戶的隱私和個人信息保護，也會採取合理的措施保護用戶的個人信息。除法律法規規定或本政策另有約定的情形外，我們將運用各種安全技術和程序建立完善的管理制度來保護您的個人信息，以免遭受未經授權的訪問、使用或披露。未經用戶許可我們不會向第三方公開、透露用戶個人信息，我們會對相關信息採用專業加密存儲與傳輸方式，保障用戶個人信息的安全。",
    u0218: "數據安全措施",
    u0219: "我們已採用符合業界標準的安全防護措施，包括建立合理的制度規範、安全技術來防止您的個人信息遭到未經授權的訪問使用、修改，避免數據的損壞或丟失。",
    u0220: "我們已採取一切合理可行的措施，確保未收集無關的個人信息。我們只會在達成本政策所述目的所需的期限內保留您的個人信息，除非需要延長保留期或受到法律的允許。",
    u0221: "互聯網並非絕對安全的環境，而且電子郵件、即時通訊、及與其他用戶的交流方式並未加密，我們強烈建議您不要通過此類方式發送個人信息。請使用複雜密碼，協助我們保證您的賬號安全。",
    u0222: "在不幸發生個人信息安全事件後，我們將按照法律法規的要求，及時向您告知：安全事件發生的原因、可能造成的危害、涉及個人信息的種類、我們已採取或將要採取的處置措施、您可自主防範和降低風險的建議和可採取的措施等。我們將及時將事件相關情況以電子郵件、短信、電話、發送通知等方式告知您，難以逐一告知個人信息主體時，我們會採取合理、有效的方式發佈公告。同時，我們還將按照監管部門要求，主動上報個人信息安全事件的處置情況。請您知悉，根據可適用法律法規的規定，如採取措施能夠有效避免信息洩露、篡改、丟失造成危害的，我們可以不向您進行告知。",
    u0223: "五、我們如何存儲您的個人信息",
    u0224: "存儲信息的地點",
    u0225: "{{common.appName}}遵守法律法規的規定，收集的有關您的信息和資料將保存在中華人民共和國境內大陸地區{{common.appName}}的服務器上。以下情形除外：",
    u0226: "法律法規有明確規定；",
    u0227: "獲得您的明確授權；",
    u0228: "您通過互聯網進行跨境交易等個人主動行為。",
    u0229: "存儲信息的期限",
    u0230: "我們僅在為提供{{common.appName}}服務之目的所必需的期間內保留您的個人信息：例如：",
    u0231: "手機號碼：當您使用手機號碼註冊登錄時，我們需要持續保留您的手機號碼，以便於向您提供正常的服務、應對您可能的查詢和客訴，並保障您的賬號和系統安全。",
    u0232: "您的付費充值等相關信息，在您未撤回、刪除或未註銷賬號期間，我們會保留相關信息用於向您提供持續的業務功能。",
    u0233: "如果您註銷賬號、主動刪除個人信息或超出必要的期限後，我們將對您的個人信息進行刪除或匿名化處理，但以下情況除外：",
    u0234: "遵從法律法規有關信息留存的要求（例如：《網絡安全法》規定：採取監測、記錄網絡運行狀態、網絡安全事件的技術措施，並按照規定留存相關的網絡日誌不少於六個月）。",
    u0235: "出於財務、審計、爭議解決等目的需要合理延長期限的。",
    u0236: "當本服務發生停止運營的情形時，{{common.appName}}將採取包括發送通知和公告形式通知您，並在法律法規要求的期限內刪除服務器中留存的您的個人信息。",
    u0237: "六、您如何實現管理您個人信息的權利",
    u0238: "您的個人信息權利",
    u0239: "按照中國相關的法律、法規、標準，您在個人信息處理活動中享有若干權利，具體包括：",
    u0240: "您對個人信息處理享有知情權、決定權，有權限制或者拒絕他人對您個人信息進行處理，法律、行政法規另有規定的除外；",
    u0241: "您有權向個人信息處理者查閱、複製您的個人信息，法律另有規定情形的除外；",
    u0242: "您有權請求將您的個人信息轉移至您指定的個人信息處理者；",
    u0243: "您發現您的個人信息不準確或不完整的，有權請求個人信息處理者更正、補充；",
    u0244: "您有權請求刪除您的個人信息；",
    u0245: "您有權要求個人信息處理者對其個人信息處理規則進行解釋說明。",
    u0246: "行使權利的方式",
    u0247: "我們保障您對自己的個人信息行使前述權利，並為您提供相關操作路徑，具體地，您可以參考以下步驟進行相關操作：",
    u0248: "改變或撤回授權範圍",
    u0249: "您可以在設備本身的操作系統中，關閉相機權限，改變同意範圍或撤回您的授權。",
    u0250: "具體地，您可以通過以下方式進行操作：",
    u0251: "安卓：系統設置 → 應用設置 → 應用管理 → 搜索或查找{{common.appName}} → 權限管理 → 選擇對應權限 → 關閉",
    u0252: "iOS：系統設置 → {{common.appName}} → 選擇對應權限 → 關閉",
    u0253: "請您知悉，具體的關閉方式可能因您使用設備型號、系統版本的不同而不盡相同。請您理解，當您執行上述操作後，我們將無法繼續為您提供撤回同意或授權所對應的服務，我們將不再收集與這些權限相關的信息，但不會影響此前基於您的授權而開展的個人信息處理。",
    u0254: "查閱、複製、更正、補充、刪除您的個人信息",
    u0255: "您可以通過如下方式查閱、複製、更正、補充或刪除您的個人信息：",
    u0256: "查閱/更正/補充賬號信息：點擊頭像賬號區域，進行操作",
    u0257: "查閱/刪除歷史對話：展開對話框左側 → 選擇歷史對話 → 刪除，或點擊頭像賬號區域 → 選擇“刪除所有對話”",
    u0258: "複製/修改歷史對話：選擇對話框內的輸入內容 → 複製/修改",
    u0260: "由於應用版本的升級和功能的變動，上述具體的操作步驟可能不同，以應用內實際的操作步驟為準。除上述外，如果您或其他有權主體對相關法律法規賦予您的個人信息權利的行使，有任何主張、要求或者疑問，您可以通過第十六節列明的聯繫方式與我們聯繫，我們將盡快審核所涉問題，並在驗證您的用戶身份後的十五個工作日內回覆。對於那些無端重複、需要過多技術手段（例如，需要開發新系統或從根本上改變現行慣例）、給他人合法權益帶來風險或者非常不切實際（例如，涉及備份磁帶上存放的信息）的請求，{{common.appName}}可能會予以拒絕。",
    u0261: "逝者的個人信息保護",
    u0262: "我們會持續確保我們的用戶信息安全無虞。若{{common.appName}}的用戶不幸去世，其近親屬（以下簡稱“逝者近親屬”）為了自身的合法、正當利益，可通過第十六節列明的方式，與我們取得聯繫，在不違反逝者生前安排且不侵害他人和公眾正當利益的前提下，對逝者的相應個人信息行使查閱、複製、更正、刪除等權利。為了充分保護逝者的個人信息權益，申請行使該等權利的逝者近親屬需要完成身份核驗手續，並承諾和保證逝者近親屬行使該等權利不違背逝者生前的安排，且行使權利的目的具有合法正當性。",
    u0263: "註銷賬號",
    u0264: "您有權根據《{{common.appName}}註銷須知》註銷您的賬號，您可以通過“主頁” → “個人信息” → “註銷賬號”或根據第十六節列明的方式聯繫我們進行賬號註銷。在您註銷賬號前，我們將驗證您的個人身份、安全狀態、財產結清情況、設備信息等。我們將會在收到您的申請後及時進行處理，並在十五個工作日或法律法規要求的時限內回覆您的請求。您知悉並理解，註銷賬號的行為是不可逆的行為，當您註銷賬號後，我們將刪除有關您的相關信息或進行匿名化處理，但法律法規及相關國家標準另有規定的除外。",
    u0265: "七、我們如何保護未成年人的個人信息",
    u0266: "{{common.appName}}主要服務成年人，但我們依然非常重視對未成年人個人信息的保護。",
    u0267: "若您是未滿18週歲的未成年人，在使用本產品及相關服務前，請在您的父母或其他監護人的監護、指導下共同閱讀並同意本隱私政策。我們不會主動收集未滿14週歲的未成年人（兒童）的個人信息。如果我們發現或接到反饋，在未事先獲得監護人同意的情況下自動收集了兒童的個人信息，則會設法盡快刪除相關信息。",
    u0268: "若您是未成年人的父母或監護人，如您對本政策所述相關事宜有任何疑問、意見、建議或投訴、舉報需求，請通過第十六節列明的方式與我們進行反饋。",
    u0269: "八、服務內容",
    u0270: "1.1",
    u0271: " 我們的產品及服務包括我們以網站、應用程序（可能含不同版本）、小程序、供第三方網站和應用程序使用的軟件開發工具包（SDK）、應用程序編程接口（API）以及隨技術發展出現的創新形態方式向您提供的產品與服務，包括但不限於以生成式人工智能服務為核心功能以及其他功能的平台（以下稱“{{common.appName}}”或“本服務”）。",
    u0272: "1.2",
    u0273: " 我們提供的生成式人工智能產品和服務以Chat大語言模型為基礎。Chat大語言模型基於深度神經網絡算法，依次經過大規模自監督學習的預訓練以及針對性的優化訓練等階段開發而成，該模型可以通過對輸入信息（包括文本、圖片、文件等）進行編碼和計算來預測下一個詞元，從而具備文本生成和對話等能力，其能夠熟練執行基於文本生成的廣泛的不同任務，並可以集成到各種下游系統或應用中。具體到{{common.appName}}產品服務中，模型基於用戶輸入信息（以下稱“輸入”），通過計算推理輸出相應的內容作為響應（以下稱“輸出”、“生成內容”），包括文字、表格和代碼等。用戶可對輸出進行評價，包括點讚、踩等操作，以反饋用戶對{{common.appName}}輸出信息的意見。Chat模型信息如下：",
    u0274: "平台",
    u0275: "模型",
    u0276: "微軟",
    u0277: "gpt-3.5-turbo",
    u0278: "文心一言",
    u0279: "ERNIE-4.5-TURBO-32k",
    u0280: "豆包",
    u0281: "Doubao-1.5-pro-32k",
    u0282: "智譜AI",
    u0283: "GLM-4.5-Flash",
    u0284: "MiniMax",
    u0285: "MiniMax-Text-01",
    u0286: "DeepSeek",
    u0287: "Deepseek-chat",
    u0288: "訊飛星火",
    u0289: "lite",
    u0290: "通義千問",
    u0291: "Qwen-plus",
    u0292: "1.3",
    u0293: " 隨著生成式人工智能的技術、模型和產品的不斷迭代發展以及法律、法規的變化，我們可能對服務進行新增、升級、變更、中止或終止，或對服務的技術、方式、性能等進行必要的調整，並可能針對新增服務功能開展內部或外部測試。",
    u0294: "1.4",
    u0295: " 我們將採取不低於行業實踐的必要措施，保障平台的網絡安全和穩定運行，並努力提升和改進技術，保障您的產品和服務使用體驗。如您對我們的服務有任何問題或反饋，可通過第十六節列明的方式與我們聯繫。",
    u0296: "九、賬號管理",
    u0297: "2.1",
    u0298: " 本服務主要面向成年人。若您未滿18週歲，請在監護人陪同下閱讀本文件並取得同意後使用；未成年人個人信息保護規則詳見",
    u0299: "第七節",
    u0300: "。",
    u0301: "2.2",
    u0302: " 您在使用本服務前，應根據頁面通過手機號碼或第三方賬號註冊賬號，按要求填寫真實、準確、合法、有效的相關信息，並確認同意本協議以及其他相關規則、政策。若您提交的材料或提供的信息不準確、不真實、不規範或公司有理由懷疑為錯誤、不實、不合法的資料，則我們有權拒絕為您提供相關功能，您可能無法使用本軟件及相關服務或在使用過程中部分功能受到限制。您的賬號是您登錄及使用本服務的憑證，該賬號不可轉讓、不可贈與、不可繼承。",
    u0303: "2.3",
    u0304: " 在您註冊和使用賬號時，您須承諾和保證：",
    u0305: "對註冊信息的真實性、合法性、有效性承擔全部責任，及時更新註冊信息，不得冒用他人的名義註冊賬號或使用本服務；",
    u0306: "妥善保管賬號及密碼，並對該賬號項下的所有行為承擔法律責任；",
    u0307: "不得惡意註冊賬號，包括但不限於頻繁註冊、批量註冊等行為；",
    u0308: "不得以任何形式將賬號轉讓、出借、出租或提供給他人使用。",
    u0309: "2.4",
    u0310: " 如您丟失賬號、遺忘密碼或洩露驗證碼，您可及時申訴請求找回。我們特別提醒您應妥善保管您的賬號、密碼及驗證碼。當您使用完畢後，應安全退出。對於用戶因賬號或密碼洩露造成的各種損失，您將自行承擔相應責任。用戶發現任何非法使用用戶賬號的情況，應立即通知我們，我們將給予最大限度地配合和處理。",
    u0311: "2.5",
    u0312: " 如用戶向我們提出註銷賬戶，經我們審核同意，由我們註銷該註冊用戶，用戶即解除與我們的合同關係。但用戶註銷賬號後，我們仍有權：",
    u0313: "按照法律法規的要求，保留該用戶的註冊數據及以前的行為記錄；",
    u0314: "對用戶在註銷前在使用本服務過程中存在違法行為或違反本協議的行為，行使本協議所約定的權利。",
    u0315: "十、使用規範",
    u0316: "3.1",
    u0317: " 您充分理解並同意，依據本協議，我們授予您一項可撤銷的、不可轉讓的和非獨佔地的合法使用本產品及相關服務的權利。本協議未明示授權的其他一切權利仍由{{common.appName}}保留，您在行使該些權利前須另行獲得{{common.appName}}的書面許可，同時{{common.appName}}如未行使前述任何權利，並不構成對該權利的放棄。如果您對外發佈或傳播本服務生成的輸出，您應當：",
    u0318: "主動核查輸出內容的真實性、準確性，避免傳播虛假信息；",
    u0319: "以顯著方式標明該輸出內容系由人工智能生成，以向公眾提示內容合成的情況；",
    u0320: "避免發佈和傳播任何違反本協議使用規範的輸出內容。",
    u0321: "3.2",
    u0322: " 您在使用我們提供的上述服務時，應遵守法律法規的要求和本協議的約定，遵守自願、平等、公平及誠實信用原則，不利用本服務侵犯他人合法權益及謀取不正當利益，不擾亂互聯網平台正常秩序。",
    u0323: "3.3",
    u0324: " 作為本服務的使用者，您不得違反《互聯網信息服務管理辦法》《網絡信息內容生態治理規定》《生成式人工智能服務管理暫行辦法》等法律法規以及相關標準關於網絡信息內容安全的要求，不得輸入、利用本服務輸出或傳播以下違法不良信息：",
    u0325: "反對憲法所確定的基本原則的；",
    u0326: "危害國家安全，洩露國家秘密，顛覆國家政權，破壞國家統一的；",
    u0327: "損害國家榮譽和利益的；",
    u0328: "歪曲、醜化、褻瀆、否定英雄烈士事跡和精神，以侮辱、誹謗或者其他方式侵害英雄烈士的姓名、肖像、名譽、榮譽的；",
    u0329: "宣揚恐怖主義、極端主義或者煽動實施恐怖活動、極端主義活動的；",
    u0330: "煽動民族仇恨、民族歧視，破壞民族團結的；",
    u0331: "破壞國家宗教政策，宣揚邪教和封建迷信的；",
    u0332: "散佈謠言，擾亂經濟秩序和社會秩序的；",
    u0333: "散佈淫穢、色情、賭博、暴力、兇殺、恐怖或者教唆犯罪的；",
    u0334: "侮辱或者誹謗他人，侵害他人名譽、隱私和其他合法權益的；",
    u0335: "法律、行政法規禁止的其他內容。",
    u0336: "3.4",
    u0337: " 為履行法定義務的要求，{{common.appName}}有權採取技術手段等措施對用戶使用本服務的行為及信息進行審查，包括但不限於對輸入和輸出進行審查、建立風險過濾機制、建立違法內容特徵庫等。作為本服務的使用者，您不得通過以下方式惡意對抗本服務的信息內容安全管理和風險防範機制，包括但不限於：",
    u0338: "惡意對抗行為，包括但不限於使用變體、亂碼、字符、諧音等方式規避服務檢測來輸入或生成違反上述3.3的言論；",
    u0339: "通過假扮身份、反向誘導、越獄攻擊等方式進行惡意攻擊、誘導和投毒；",
    u0340: "未經{{common.appName}}同意或未有合法正當依據，擅自去除、篡改本服務涉及的生成內容標識。",
    u0341: "3.5",
    u0342: " 作為本服務的使用者，您不得違反《網絡安全法》《數據安全法》等法律法規以及相關標準的要求，不得對本服務以及支持本服務正常運行的系統、網絡、模型以及其他組件等進行干擾、破壞或攻擊，不得從事以下危害本服務安全的活動：",
    u0343: "從事非法侵入網絡的活動，例如：使用未經許可的數據或進入未經許可的服務器/賬號；偽造TCP/IP數據包名稱或部分名稱；未經許可，企圖探查、掃描、測試本軟件系統或網絡的弱點等；",
    u0344: "從事干擾、破壞網絡正常功能的活動，例如：故意生成、傳播惡意程序或病毒；未經允許進入公眾計算機網絡或者他人計算機系統並刪除、修改、增加存儲信息；以導致計算機系統或設施承受不合理負載的方式干擾運營等；",
    u0345: "從事竊取網絡數據的活動，例如：對本軟件及相關服務進行反向工程、反向彙編、反向編譯、翻譯或者以其他方式嘗試發現本軟件的源代碼、模型、算法和系統的源代碼或底層組件；以任何方式（包括但不限於通過任何機器人、爬蟲、其他自動設置、設置鏡像）來抓取、複製本服務及其所包含的任何內容等；",
    u0346: "從事其他危害本服務系統、網絡、模型以及其他組件安全的活動。",
    u0347: "3.6",
    u0348: " 作為本服務的使用者，您不得利用本服務用於以下不當目的：",
    u0349: "將本服務用於任何違反法律法規、監管政策或侵犯第三方合法權益的非法目的；",
    u0350: "將本服務用於可能對人身健康、心理、社會或經濟等產生嚴重有害影響或違反科技倫理的危險目的；",
    u0351: "從事侵犯知識產權、商業秘密以及其他違反商業道德的行為，或利用算法、數據、平台等優勢，實施壟斷和不正當競爭行為；",
    u0352: "未經{{common.appName}}授權，將服務的全部或部分進行複製、轉讓、出租、出借、出售或提供分許可、轉許可；",
    u0353: "其他法律、行政法規所禁止、限制的，或可能損害{{common.appName}}利益的使用方式。",
    u0354: "十一、輸入與輸出",
    u0355: "4.1",
    u0356: " 您對提交給我們服務的所有輸入和對應的輸出負責。您聲明並保證您向我們的服務提交的輸入，您擁有根據我們的條款處理輸入所需的所有權利、許可和權限，這些輸入和對應的輸出不侵犯任何人的知識產權、肖像權、名譽權、榮譽權、姓名權、隱私權、個人信息權益等合法權益，不涉及任何國家秘密、商業秘密或其他可能會對國家安全或者公共利益造成不利影響的數據。",
    u0357: "4.2",
    u0358: " 在符合法律規定和我們的條款的條件下，您對本服務的輸入與輸出享有以下權利：",
    u0359: "您保留在提交的輸入中擁有的任何權利、所有權和利益（如有）；",
    u0360: "我們將本服務輸出的內容的任何權利、所有權和利益（如有）歸屬於您；",
    u0361: "您可將本服務的輸入與輸出應用於廣泛的使用場景中，包括個人使用、學術研究、衍生產品開發、訓練其他模型（如模型蒸餾）等。",
    u0362: "4.3",
    u0363: " 本服務提供的所有輸出均由人工智能模型答覆，可能出現錯誤或遺漏，僅供您參考，您不應將輸出的內容作為專業建議。特別的，當您在使用本服務諮詢醫療、法律、金融及其他專業問題時，請注意本服務不構成任何建議或承諾，不代表任何專業領域的意見。若您需要相關專業服務，應諮詢專業人士，並在專業人士的指導下作出決策。本軟件的輸出不應成為您進一步作為或不作為的依據。您根據輸出的內容所作出的任何判斷或者據此作出的後續相關操作行為，所帶來的後果和責任均由您自行承擔，包括因對輸出的內容的真實性、準確性、可靠性、不侵權或滿足特定目的的依賴而產生的風險。您應科學理性認識和依法使用生成式人工智能技術。",
    u0364: "4.4 個人信息處理規則",
    u0365: "您理解並同意，我們在提供本服務過程中可能涉及對您個人信息的處理。處理目的、方式、信息類型、保存期限、您的權利及第三方共享等規則，以本文件",
    u0366: "「個人信息處理總則」及第一至七節",
    u0367: "為準；其中第三方 SDK 收集使用規則詳見",
    u0368: "第三節",
    u0369: "。如您對個人信息處理有疑問或需拒絕模型訓練等特定用途，可通過",
    u0370: "第十六節",
    u0371: "列明方式聯繫我們。",
    u0372: "4.5",
    u0373: " 為履行法律法規所規定的要求以及提供本協議約定的服務，您知悉並授權，在符合第4.4條所述個人信息處理規則的前提下，我們可能會將服務所收集的輸入及對應輸出（經安全加密技術處理、嚴格去標識化且無法重新識別特定個人）用於本協議下服務的優化以及統計分析、問題排查、安全風控等目的。如您拒絕我們按照上述方式處理數據，可以通過第十六節列明的聯繫方式向我們反饋。",
    u0374: "十二、知識產權和其他權利",
    u0375: "5.1",
    u0376: " {{common.companyName}}為本服務的開發、運營主體，對本服務（包括但不限於軟件、技術、程序、代碼、模型權重、用戶界面、網頁、文字、圖表、版面設計、商標、電子文檔等）享有法律法規允許範圍內的全部權利（包括但不限於著作權、商標權、專利權和其他知識產權），但相關權利人依照法律規定或本協議的約定應享有權利（如輸入與輸出）的除外。",
    u0377: "5.2",
    u0378: " 未經我們許可，請不要擅自使用本產品相關的包括但不限於“{{common.appName}}”等在內的任何商標、服務標記、商號、域名、網站名稱、公司徽標 (LOGO)、URL或其他顯著品牌特徵等，不得將本條款前述標識以單獨或結合任何方式展示、使用或申請註冊商標、進行域名註冊等，也不得實施向他人明示或暗示有權展示、使用、或其他有權處理該些標識的行為。",
    u0379: "十三、違約責任與責任限制",
    u0380: "7.1",
    u0381: " 針對您違反本協議或其他服務條款的行為，我們有權獨立判斷，無需通知對您採取警示提醒、限期改正、限制賬號功能、暫停使用、關閉賬號、禁止重新註冊、刪除相關內容等處置措施。我們有權公告處理結果，且有權根據實際情況決定是否恢復使用。對涉嫌違反法律法規、涉嫌違法犯罪的行為將保存有關記錄，並依法向有關主管部門報告、配合有關主管部門調查。由此而導致或產生的法律責任或第三方主張的任何索賠、要求或損失，您應當自行承擔責任；因此給我們造成任何損失的，您也應當一併賠償（包括我們維權所支出的訴訟費、仲裁費、律師費、公證費、公告費、鑑定費、差旅費、調查取證費、賠償金、違約金、和解費用、行政處罰的罰金等）。",
    u0382: "7.2",
    u0383: " 我們致力於提供安全、穩定、持續的服務，保障用戶正常使用，但本服務僅以“現狀”、“當前功能”的狀態提供。儘管我們已經盡了最大努力，但是由於本服務所依賴的技術本身存在的技術瓶頸和科技客觀限制，我們不能對以下事項作出任何保證，具體如下：",
    u0384: "不保證本服務在操作上不會中斷、沒有錯誤、不受干擾、持續穩定或不存在任何故障；",
    u0385: "不保證在現有技術水平下有能力糾正本服務的所有缺陷；",
    u0386: "限於技術特性，不保證本服務生成內容的合法性、真實性、完整性、準確性、及時性及實用性，不排除通過提示詞惡意誘導等違反本協議的使用方式/目的可能輸出的包含與本服務運營主體觀點不一致的內容；",
    u0387: "本服務的輸入和輸出雖已經過過濾審查，但仍不排除無法發現您的輸入或本服務輸出中存在違規問題，不排除其中部分信息具有瑕疵、存在虛假內容或存在不合理、引發用戶不適的地方；",
    u0388: "由於人工智能模型的特性，就相同的上傳至本服務平台的內容（包括但不限於作為提示詞的文本或其他一切用於協助產生人工智能生成內容的提示性內容），本服務可能生成不同的內容結果；",
    u0389: "不保證本服務能滿足用戶的所有要求；",
    u0390: "當本服務提供的內容包含來自插件、第三方網站等內容時，我們並不對這些內容的有效性負責，且不保證從這些途徑獲取的任何內容、產品、服務或其他材料的真實性、合法性、安全性。",
    u0391: "7.3",
    u0392: " 不論在何種情況下，本服務均不對由於網絡連接故障，電力故障，罷工，勞動爭議，暴亂，起義，騷亂，火災，洪水，風暴，爆炸，不可抗力，戰爭，政府行為，國際、國內法院的命令，黑客攻擊，互聯網病毒，網絡運營商技術調整，政府臨時管制或任何其他不能合理控制的原因而造成的本服務不能訪問、服務中斷、信息及數據的洩露、延誤、停滯或錯誤，不能提供或延遲提供服務而承擔責任。",
    u0393: "7.4",
    u0394: " 我們可能會不時推出新的功能，我們提示您，在新功能測試期可能存在服務不穩定等情況，除法律有明確規定外，我們無法也不對處於測試期的功能服務的穩定性等進行保證。",
    u0395: "十四、法律適用和管轄",
    u0396: "8.1",
    u0397: " 本協議的訂立、執行和解釋及爭議的解決均應適用中華人民共和國大陸地區法律。",
    u0398: "8.2",
    u0399: " 本協議的簽訂、履行或解釋發生爭議，雙方應努力友好協商解決。如協商不成，任何一方均有權向{{common.companyName}}住所地有管轄權的法院起訴。",
    u0400: "十五、本文件如何更新",
    u0401: "為向您提供更好的服務，我們可能因法律法規、政策調整、技術條件或產品功能變化，適時修訂本文件（包括隱私政策與用戶協議相關條款）。修訂內容構成本文件的組成部分。",
    u0402: "更新後，我們將在{{common.appName}}官方網站或應用內以公告等方式發佈最新版本，請您及時查閱。",
    u0403: "若您不同意修訂內容，可停止使用本服務或註銷賬號；您繼續使用即視為接受修訂後的內容。停止使用或註銷前已發生的行為，仍受當時有效版本約束。",
    u0404: "對會導致您個人信息相關權益實質減損的重大變更，我們將通過電子郵件、短信或頁面顯著提示等方式另行告知。",
    u0405: "十六、如何聯繫我們",
    u0406: "如您對本文件、個人信息處理、賬號與服務使用有任何疑問、意見、建議、投訴、申訴或舉報，可通過以下方式聯繫我們：",
    u0407: "應用內反饋：登錄產品界面 → 點擊「聯繫我們」",
    u0408: "聯繫郵箱：{{common.contactEmail}}",
    u0409: "聯繫地址：{{common.contactAddress}}",
    u0410: "運營主體：{{common.companyName}}",
    u0411: "涉及知識產權侵權、違法信息或違反本文件約定的使用行為，您亦可通過上述渠道如實反饋，我們將依法處理。",
    u0412: "我們可能需您提供有效聯繫方式、書面請求及相關證明材料；我們將在驗證身份後處理，並於",
    u0413: "十五個工作日內",
    u0414: "回覆。對於無端重複、需過多技術投入或可能損害他人合法權益的請求，我們可能不予受理。",
  }
}